import { FC } from 'react';
import Svg, { SvgProps } from '@/components/shared/Svg/Svg.tsx';

const Default: FC<Omit<SvgProps, 'children'>> = (props) => {
  return (
    <Svg viewBox="0 0 3078 897" {...props}>
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M2139.000000,898.000000
	C1426.000000,898.000000 713.500000,898.000000 1.000000,898.000000
	C1.000000,599.000000 1.000000,300.000000 1.000000,1.000000
	C1027.000000,1.000000 2053.000000,1.000000 3079.000000,1.000000
	C3079.000000,300.000000 3079.000000,599.000000 3079.000000,898.000000
	C2765.833252,898.000000 2452.666748,898.000000 2139.000000,898.000000
M232.537964,558.956177
	C230.687332,562.004944 228.984833,565.157104 226.947525,568.075562
	C224.552597,571.506287 225.134064,573.826843 228.167648,576.826172
	C252.937515,601.315979 277.500000,626.015381 302.157532,650.619019
	C303.383667,651.842468 304.906006,652.769043 306.290436,653.833862
	C305.995636,654.222595 305.700836,654.611267 305.406036,655.000000
	C303.787231,655.000000 302.168427,655.000000 300.549622,655.000000
	C260.549835,655.000000 220.550003,654.978149 180.550491,655.078369
	C178.915436,655.082458 176.465897,655.752441 175.772568,656.925720
	C165.638519,674.075439 155.766891,691.379883 145.775360,708.614258
	C137.321869,723.195557 128.750244,737.708496 120.323067,752.304871
	C117.291725,757.555298 114.529167,762.960815 111.262970,769.000000
	C114.209076,769.000000 116.173798,769.000000 118.138527,769.000000
	C274.304321,769.000000 430.470215,768.943726 586.635620,769.193726
	C593.281250,769.204407 596.489136,767.026367 599.300171,761.451233
	C610.264282,739.706238 621.525085,718.108643 632.899414,696.574402
	C635.441833,691.761230 636.692566,687.581787 632.610474,683.011414
	C631.030151,681.242004 630.177368,678.829163 628.959229,676.729126
	C613.997192,650.935303 598.957581,625.186218 584.081848,599.342834
	C568.497925,572.269043 553.069763,545.105591 537.584290,518.000122
	C507.634003,518.000122 477.971924,517.952209 448.311188,518.130188
	C446.691315,518.139893 444.476807,519.656250 443.568085,521.113098
	C437.997223,530.044189 432.665405,539.126831 427.374298,548.228943
	C424.675018,552.872559 422.226349,557.661865 419.330994,563.000000
	C422.194702,563.000000 424.016449,563.000000 425.838196,563.000000
	C451.171387,563.000000 476.504730,562.964355 501.837402,563.079590
	C503.544891,563.087341 506.095642,563.724976 506.818115,564.930359
	C512.732605,574.798279 518.251770,584.902039 523.995972,594.873596
	C532.081726,608.909790 540.291504,622.874451 548.378418,636.910034
	C551.727539,642.722778 554.895813,648.639771 558.360535,654.896118
	C474.944061,654.896118 392.286377,654.896118 308.820862,654.896118
	C366.012115,556.011230 423.005432,457.468445 480.472900,358.105957
	C491.822693,377.690155 502.587585,396.153381 513.242432,414.679840
	C525.277588,435.606354 537.139221,456.632843 549.214661,477.535919
	C560.723328,497.457855 572.496460,517.227051 583.995178,537.154663
	C596.139832,558.201721 608.008057,579.408447 620.161621,600.450256
	C633.292786,623.184509 646.657532,645.783813 659.836975,668.490417
	C667.886536,682.358765 675.732117,696.345520 683.753479,710.230347
	C694.127075,728.186829 704.686096,746.037109 714.915344,764.074951
	C716.829773,767.450928 718.648499,769.121704 722.817993,769.104126
	C763.650391,768.931396 804.483765,769.000000 845.316895,769.000000
	C846.706970,769.000000 848.097046,769.000000 849.977112,769.000000
	C846.383179,762.438416 843.246948,756.421753 839.848022,750.557434
	C825.383545,725.601929 810.784302,700.724487 796.345276,675.754272
	C784.750610,655.702881 773.387146,635.517822 761.791809,615.466858
	C747.352051,590.497253 732.764709,565.612976 718.269836,540.675232
	C710.048706,526.531189 701.886414,512.352966 693.695312,498.191467
	C683.473022,480.518372 673.231140,462.856628 663.030029,445.171326
	C654.612549,430.578247 646.256226,415.949951 637.846741,401.352264
	C629.919250,387.591339 621.756775,373.959595 614.162415,360.017792
	C612.415649,356.811096 610.730713,355.932220 607.390442,355.939972
	C567.390869,356.032867 527.390991,356.000000 487.391235,356.000000
	C485.785370,356.000000 484.179535,356.000000 482.128357,356.000000
	C482.817383,354.597351 483.260712,353.562653 483.813263,352.590027
	C491.653809,338.788666 499.424835,324.946808 507.380402,311.211884
	C519.966675,289.482178 532.716187,267.846863 545.245972,246.084839
	C545.999756,244.775589 546.087402,242.333252 545.367432,241.040619
	C537.959351,227.740097 530.353577,214.549042 522.738831,201.364456
	C509.451569,178.358017 496.125641,155.373856 482.781647,132.400284
	C482.261108,131.504089 481.387207,130.813171 480.677979,130.026566
	C479.819489,130.849823 478.712738,131.530228 478.143311,132.519821
	C474.751740,138.413849 471.550385,144.417282 468.162567,150.313538
	C458.800964,166.606689 449.396576,182.875366 439.975159,199.134079
	C431.932709,213.013092 423.803741,226.842056 415.785004,240.734680
	C406.472473,256.868805 397.240723,273.049591 387.969635,289.207642
	C379.743469,303.544556 371.538513,317.893768 363.274750,332.209015
	C353.879120,348.484924 344.398682,364.711853 335.010437,380.992004
	C325.783447,396.992371 316.651123,413.047241 307.430847,429.051453
	C297.970734,445.472015 288.465820,461.866730 278.958923,478.260254
	C271.886108,490.456451 264.722351,502.600250 257.701508,514.826172
	C249.393768,529.292969 241.196045,543.822937 232.537964,558.956177
M1660.998657,576.498535
	C1667.652832,587.243591 1674.315796,597.983215 1680.955933,608.736938
	C1683.037964,612.109192 1684.066406,611.981812 1686.297852,608.321899
	C1692.200928,598.639832 1698.180908,589.004517 1704.143555,579.358826
	C1716.749512,558.966370 1729.348389,538.569641 1741.984619,518.196045
	C1745.336304,512.791809 1748.812744,507.464752 1752.693359,501.378662
	C1757.861450,546.296021 1762.897339,590.064697 1767.919067,633.710083
	C1785.698853,633.710083 1802.784790,633.710083 1820.041382,633.710083
	C1808.107178,549.385986 1796.216553,465.370667 1784.168701,380.244446
	C1750.210449,432.618225 1717.005249,483.830383 1683.538086,535.446533
	C1649.757568,483.948792 1616.976807,432.501556 1583.468018,381.537811
	C1583.137207,381.822754 1582.806396,382.107697 1582.475708,382.392639
	C1570.631958,466.102142 1558.788086,549.811646 1546.906982,633.785156
	C1564.395752,633.785156 1581.494507,633.785156 1599.032593,633.785156
	C1604.025269,590.479675 1609.006226,547.276855 1613.987183,504.074097
	C1614.414062,503.960144 1614.840942,503.846161 1615.267700,503.732178
	C1616.195679,504.934662 1617.226318,506.072113 1618.035645,507.349762
	C1625.670044,519.402405 1633.344238,531.431030 1640.851196,543.562988
	C1647.494995,554.300232 1653.940674,565.160095 1660.998657,576.498535
M1098.531738,635.006958
	C1102.629761,633.547363 1106.868530,632.392334 1110.801147,630.574646
	C1126.764404,623.195740 1140.522339,612.950806 1151.507202,599.047913
	C1161.380371,586.552124 1168.896729,572.848145 1172.919434,557.444641
	C1175.126221,548.994141 1176.889038,540.358032 1177.941406,531.695007
	C1179.005005,522.938599 1178.944580,514.045654 1179.369263,505.360596
	C1138.926392,505.360596 1099.535522,505.360596 1060.210327,505.360596
	C1060.210327,518.666138 1060.210327,531.610168 1060.210327,544.971497
	C1083.105469,544.971497 1105.795776,544.971497 1129.324829,544.971497
	C1126.625488,550.932800 1124.604370,556.440857 1121.753540,561.479553
	C1115.388428,572.729248 1107.004883,582.159546 1095.164429,587.960022
	C1080.708862,595.041687 1065.606567,597.155823 1049.528198,595.160950
	C1033.234863,593.139465 1019.158020,586.856018 1007.406799,575.753174
	C994.380005,563.445251 986.762146,548.190491 983.847900,530.335632
	C981.460510,515.709351 981.868347,501.361359 986.096985,487.281647
	C992.421448,466.223785 1005.412903,450.576752 1025.509277,441.157013
	C1035.981567,436.248383 1046.929077,434.166901 1058.578979,433.829254
	C1081.135254,433.175568 1100.020386,440.343750 1114.887451,457.450806
	C1118.059937,461.101288 1120.839111,465.093781 1123.845093,468.987640
	C1137.930908,460.809143 1152.022705,452.627228 1166.476807,444.234863
	C1159.439087,433.818176 1151.843262,424.617828 1142.408936,416.732361
	C1122.650879,400.218201 1099.854248,391.082092 1074.516357,389.259308
	C1059.311279,388.165497 1043.972412,388.480438 1028.711914,391.792603
	C1001.480835,397.702850 978.145630,409.754211 959.590637,430.843292
	C941.143372,451.809814 932.123962,476.568542 930.147400,503.970276
	C929.201111,517.088440 930.046936,530.248291 932.891724,543.270508
	C938.773315,570.194336 951.081909,593.113464 972.436462,611.039307
	C996.426880,631.177612 1024.448486,639.788025 1055.176147,640.919739
	C1061.246704,641.143311 1067.421387,640.780518 1073.430176,639.890869
	C1081.582764,638.683655 1089.621460,636.708130 1098.531738,635.006958
M2647.330566,634.000000
	C2649.528564,634.000000 2651.726562,634.000000 2654.688965,634.000000
	C2632.687744,602.553467 2611.352539,572.058472 2589.902832,541.400208
	C2591.497070,540.795593 2592.562012,540.417908 2593.606934,539.991516
	C2610.870117,532.947815 2624.602539,521.636353 2632.519775,504.680298
	C2640.073975,488.501984 2641.633545,471.389648 2638.147217,453.591309
	C2632.831299,426.451752 2615.966309,409.997772 2591.314697,399.954346
	C2577.387939,394.280396 2562.634277,393.569519 2548.031006,393.178986
	C2523.553711,392.524384 2499.045898,393.000000 2474.551025,393.000000
	C2472.785645,393.000000 2471.020508,393.000000 2469.314453,393.000000
	C2469.314453,473.656738 2469.314453,553.708923 2469.314453,633.659180
	C2486.027100,633.659180 2502.423096,633.659180 2519.270752,633.659180
	C2519.270752,604.590942 2519.270752,575.861755 2519.270752,547.000000
	C2524.886963,547.000000 2530.072998,546.697815 2535.192383,547.149780
	C2537.220703,547.328979 2539.822021,548.697876 2540.934082,550.351379
	C2549.442627,563.001770 2557.700439,575.822571 2565.934814,588.655518
	C2575.030762,602.832214 2583.930908,617.136108 2593.180908,631.210754
	C2594.180664,632.731812 2596.927002,633.854248 2598.880615,633.880554
	C2614.707764,634.093323 2630.539062,634.000000 2647.330566,634.000000
M2200.097900,393.765900
	C2200.068359,473.232880 2200.037598,552.699829 2200.031006,632.166809
	C2200.031006,632.762085 2200.360840,633.357361 2200.488525,633.788940
	C2251.357178,633.788940 2301.955566,633.788940 2352.764893,633.788940
	C2352.764893,619.851318 2352.764893,606.125000 2352.764893,591.949219
	C2317.810059,591.949219 2283.087158,591.949219 2248.270996,591.949219
	C2248.270996,570.107483 2248.270996,548.716431 2248.270996,526.876221
	C2280.929688,526.876221 2313.320068,526.876221 2345.688721,526.876221
	C2345.688721,513.029175 2345.688721,499.635071 2345.688721,485.795563
	C2312.989014,485.795563 2280.598633,485.795563 2248.350342,485.795563
	C2248.350342,468.949036 2248.350342,452.555115 2248.350342,435.718567
	C2283.422363,435.718567 2318.145264,435.718567 2352.787354,435.718567
	C2352.787354,421.325623 2352.787354,407.383118 2352.787354,393.095520
	C2301.978760,393.095520 2251.381836,393.095520 2200.097900,393.765900
M2946.496094,587.995667
	C2945.011475,584.762146 2943.568848,581.508606 2942.035645,578.298218
	C2930.506836,554.154236 2918.974365,530.011902 2907.414307,505.882812
	C2899.988281,490.383575 2892.502441,474.913086 2885.062744,459.420410
	C2872.221680,432.680023 2859.395508,405.932404 2846.422119,378.894012
	C2845.838867,379.901855 2845.306885,380.693756 2844.898682,381.545105
	C2838.246094,395.427124 2831.611328,409.317688 2824.967773,423.204193
	C2813.632324,446.898651 2802.296143,470.592743 2790.955811,494.284882
	C2779.614990,517.977539 2768.306152,541.685486 2756.914307,565.353577
	C2746.640869,586.697998 2736.273438,607.997314 2725.949951,629.317505
	C2725.270020,630.722168 2724.610596,632.136658 2723.726807,633.999146
	C2742.314697,633.999146 2760.294434,634.047058 2778.271973,633.892334
	C2779.482910,633.881958 2781.272217,632.612000 2781.795898,631.470398
	C2789.630615,614.396912 2797.297607,597.246521 2804.983154,580.160828
	C2832.450684,580.160828 2859.576904,580.160828 2886.671875,580.160828
	C2895.053467,598.182617 2903.368164,616.060425 2911.392822,633.314758
	C2930.447510,633.314758 2949.072998,633.314758 2968.291016,633.314758
	C2960.920898,617.883606 2953.932373,603.251770 2946.496094,587.995667
M2001.499268,547.000000
	C2014.192017,547.415833 2026.734009,546.490906 2039.020630,543.009338
	C2063.914795,535.955322 2082.144287,521.526794 2090.278564,496.234222
	C2095.039307,481.431458 2095.232910,466.339722 2092.021484,451.146332
	C2087.795898,431.154968 2076.659180,416.282867 2059.113281,406.003174
	C2041.621338,395.754944 2022.180786,393.619080 2002.600220,393.140900
	C1978.459839,392.551331 1954.294189,392.997070 1930.139404,393.008362
	C1928.861572,393.008972 1927.583862,393.130066 1926.258545,393.197510
	C1926.258545,473.577148 1926.258545,553.612854 1926.258545,633.720093
	C1942.910034,633.720093 1959.301514,633.720093 1976.140015,633.720093
	C1976.140015,604.720154 1976.140015,575.996887 1976.140015,547.000000
	C1984.557739,547.000000 1992.528564,547.000000 2001.499268,547.000000
M1329.535400,528.043091
	C1334.578247,533.761597 1334.059937,540.699646 1334.036865,547.629578
	C1333.946655,574.628235 1334.000000,601.627380 1334.000000,628.626343
	C1334.000000,630.374695 1334.000000,632.123047 1334.000000,633.782349
	C1351.010376,633.782349 1367.289673,633.782349 1384.000000,633.782349
	C1384.000000,631.783630 1384.000000,629.995239 1384.000000,628.206848
	C1384.000000,598.374634 1383.990112,568.542480 1384.027222,538.710327
	C1384.029175,537.113525 1383.995972,535.284546 1384.712769,533.961121
	C1387.796509,528.266785 1391.119019,522.699951 1394.418945,517.124817
	C1406.052979,497.469696 1417.714844,477.831085 1429.363525,458.184570
	C1439.114014,441.739685 1448.895630,425.313141 1458.587891,408.834076
	C1461.551514,403.795044 1464.264893,398.608765 1467.363403,393.000214
	C1448.652954,393.000214 1430.825562,392.945068 1413.000122,393.106964
	C1411.602661,393.119659 1409.618286,394.304596 1408.924683,395.523865
	C1403.871826,404.406189 1399.027832,413.409210 1394.216675,422.426819
	C1385.130249,439.457458 1376.117065,456.527252 1367.058228,473.572601
	C1364.331909,478.702240 1361.555054,483.804901 1358.684204,489.137329
	C1348.784668,470.456635 1339.097900,452.125366 1329.360718,433.821014
	C1322.582397,421.079041 1315.817871,408.327637 1308.797852,395.719269
	C1308.031372,394.342407 1305.624268,393.137726 1303.961792,393.116364
	C1288.631592,392.919037 1273.297852,393.000000 1257.965088,393.000000
	C1255.713623,393.000000 1253.462158,393.000000 1250.151611,393.000000
	C1276.787720,438.435455 1302.896240,482.970978 1329.535400,528.043091
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M232.744308,558.640869
	C241.196045,543.822937 249.393768,529.292969 257.701508,514.826172
	C264.722351,502.600250 271.886108,490.456451 278.958923,478.260254
	C288.465820,461.866730 297.970734,445.472015 307.430847,429.051453
	C316.651123,413.047241 325.783447,396.992371 335.010437,380.992004
	C344.398682,364.711853 353.879120,348.484924 363.274750,332.209015
	C371.538513,317.893768 379.743469,303.544556 387.969635,289.207642
	C397.240723,273.049591 406.472473,256.868805 415.785004,240.734680
	C423.803741,226.842056 431.932709,213.013092 439.975159,199.134079
	C449.396576,182.875366 458.800964,166.606689 468.162567,150.313538
	C471.550385,144.417282 474.751740,138.413849 478.143311,132.519821
	C478.712738,131.530228 479.819489,130.849823 480.677979,130.026581
	C481.387207,130.813171 482.261108,131.504089 482.781647,132.400284
	C496.125641,155.373856 509.451569,178.358017 522.738831,201.364456
	C530.353577,214.549042 537.959351,227.740097 545.367432,241.040619
	C546.087402,242.333252 545.999756,244.775589 545.245972,246.084839
	C532.716187,267.846863 519.966675,289.482178 507.380402,311.211884
	C499.424835,324.946808 491.653809,338.788666 483.813263,352.590027
	C483.260712,353.562653 482.817383,354.597351 482.128357,356.000000
	C484.179535,356.000000 485.785370,356.000000 487.391235,356.000000
	C527.390991,356.000000 567.390869,356.032867 607.390442,355.939972
	C610.730713,355.932220 612.415649,356.811096 614.162415,360.017792
	C621.756775,373.959595 629.919250,387.591339 637.846741,401.352264
	C646.256226,415.949951 654.612549,430.578247 663.030029,445.171326
	C673.231140,462.856628 683.473022,480.518372 693.695312,498.191467
	C701.886414,512.352966 710.048706,526.531189 718.269836,540.675232
	C732.764709,565.612976 747.352051,590.497253 761.791809,615.466858
	C773.387146,635.517822 784.750610,655.702881 796.345276,675.754272
	C810.784302,700.724487 825.383545,725.601929 839.848022,750.557434
	C843.246948,756.421753 846.383179,762.438416 849.977112,769.000000
	C848.097046,769.000000 846.706970,769.000000 845.316895,769.000000
	C804.483765,769.000000 763.650391,768.931396 722.817993,769.104126
	C718.648499,769.121704 716.829773,767.450928 714.915344,764.074951
	C704.686096,746.037109 694.127075,728.186829 683.753479,710.230347
	C675.732117,696.345520 667.886536,682.358765 659.836975,668.490417
	C646.657532,645.783813 633.292786,623.184509 620.161621,600.450256
	C608.008057,579.408447 596.139832,558.201721 583.995178,537.154663
	C572.496460,517.227051 560.723328,497.457855 549.214661,477.535919
	C537.139221,456.632843 525.277588,435.606354 513.242432,414.679840
	C502.587585,396.153381 491.822693,377.690155 480.472900,358.105957
	C423.005432,457.468445 366.012115,556.011230 308.820862,654.896118
	C392.286377,654.896118 474.944061,654.896118 558.360535,654.896118
	C554.895813,648.639771 551.727539,642.722778 548.378418,636.910034
	C540.291504,622.874451 532.081726,608.909790 523.995972,594.873596
	C518.251770,584.902039 512.732605,574.798279 506.818115,564.930359
	C506.095642,563.724976 503.544891,563.087341 501.837402,563.079590
	C476.504730,562.964355 451.171387,563.000000 425.838196,563.000000
	C424.016449,563.000000 422.194702,563.000000 419.330994,563.000000
	C422.226349,557.661865 424.675018,552.872559 427.374298,548.228943
	C432.665405,539.126831 437.997223,530.044189 443.568085,521.113098
	C444.476807,519.656250 446.691315,518.139893 448.311188,518.130188
	C477.971924,517.952209 507.634003,518.000122 537.584290,518.000122
	C553.069763,545.105591 568.497925,572.269043 584.081848,599.342834
	C598.957581,625.186218 613.997192,650.935303 628.959229,676.729126
	C630.177368,678.829163 631.030151,681.242004 632.610474,683.011414
	C636.692566,687.581787 635.441833,691.761230 632.899414,696.574402
	C621.525085,718.108643 610.264282,739.706238 599.300171,761.451233
	C596.489136,767.026367 593.281250,769.204407 586.635620,769.193726
	C430.470215,768.943726 274.304321,769.000000 118.138527,769.000000
	C116.173798,769.000000 114.209076,769.000000 111.262970,769.000000
	C114.529167,762.960815 117.291725,757.555298 120.323067,752.304871
	C128.750244,737.708496 137.321869,723.195557 145.775360,708.614258
	C155.766891,691.379883 165.638519,674.075439 175.772568,656.925720
	C176.465897,655.752441 178.915436,655.082458 180.550491,655.078369
	C220.550003,654.978149 260.549835,655.000000 300.549622,655.000000
	C302.168427,655.000000 303.787231,655.000000 305.406036,655.000000
	C305.700836,654.611267 305.995636,654.222595 306.290436,653.833862
	C304.906006,652.769043 303.383667,651.842468 302.157532,650.619019
	C277.500000,626.015381 252.937515,601.315979 228.167648,576.826172
	C225.134064,573.826843 224.552597,571.506287 226.947525,568.075562
	C228.984833,565.157104 230.687332,562.004944 232.744308,558.640869
M439.057343,351.588379
	C448.482483,335.139313 457.857513,318.661255 467.346039,302.248779
	C478.451721,283.039001 489.668579,263.893463 500.762665,244.677032
	C501.122925,244.053040 500.936218,242.810898 500.549835,242.106140
	C497.435638,236.425613 494.258484,230.778152 491.009460,225.173386
	C487.671844,219.415833 484.231445,213.717850 480.416962,207.287323
	C410.965637,327.664734 342.035156,447.139374 273.056580,566.697388
	C282.200165,575.331970 291.083832,583.721191 300.200653,592.330505
	C307.595306,579.247498 314.726593,566.405640 322.069702,553.686096
	C336.650909,528.428894 351.366943,503.249542 365.991272,478.017181
	C373.952209,464.281647 381.812592,450.487885 389.766602,436.748322
	C400.154633,418.804382 410.577698,400.880676 421.010834,382.962891
	C426.964539,372.738068 432.968292,362.542328 439.057343,351.588379
M232.500000,694.000000
	C221.509949,694.000000 210.519882,694.000000 199.607040,694.000000
	C192.720856,705.963013 185.934067,717.753296 178.958023,729.872437
	C310.453583,729.872437 441.063843,729.872437 571.461304,729.872437
	C577.592285,717.867981 583.627625,706.050781 589.782288,694.000000
	C470.750946,694.000000 352.125488,694.000000 232.500000,694.000000
M617.053833,516.376282
	C621.797424,524.487793 626.598083,532.566528 631.273376,540.717224
	C643.280762,561.650574 655.165527,582.654541 667.225769,603.557373
	C678.799561,623.617065 690.605896,643.542542 702.174561,663.605164
	C714.229675,684.511108 726.101135,705.523010 738.115967,726.452332
	C739.517151,728.893250 741.359741,730.244873 744.753235,730.135376
	C755.904602,729.775452 767.074890,730.009644 778.237915,729.986145
	C779.452637,729.983582 780.666992,729.788635 782.141541,729.660339
	C774.241150,715.705444 766.692749,702.150391 758.934448,688.716614
	C744.677734,664.030762 730.237488,639.450806 715.985535,614.762207
	C701.573303,589.795898 687.368774,564.709595 672.940430,539.752625
	C657.699890,513.390808 642.243408,487.153748 626.992676,460.797638
	C614.903931,439.905975 603.016541,418.897736 590.911072,398.015839
	C590.137634,396.681732 588.267395,395.154938 586.883789,395.131836
	C573.791077,394.913361 560.693237,395.001801 547.007507,395.001801
	C570.516541,435.549438 593.731812,475.590332 617.053833,516.376282
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M1660.736328,576.232178
	C1653.940674,565.160095 1647.494995,554.300232 1640.851196,543.562988
	C1633.344238,531.431030 1625.670044,519.402405 1618.035645,507.349762
	C1617.226318,506.072113 1616.195679,504.934662 1615.267700,503.732178
	C1614.840942,503.846161 1614.414062,503.960144 1613.987183,504.074097
	C1609.006226,547.276855 1604.025269,590.479675 1599.032593,633.785156
	C1581.494507,633.785156 1564.395752,633.785156 1546.906982,633.785156
	C1558.788086,549.811646 1570.631958,466.102142 1582.475708,382.392639
	C1582.806396,382.107697 1583.137207,381.822754 1583.468018,381.537811
	C1616.976807,432.501556 1649.757568,483.948792 1683.538086,535.446533
	C1717.005249,483.830383 1750.210449,432.618225 1784.168701,380.244446
	C1796.216553,465.370667 1808.107178,549.385986 1820.041382,633.710083
	C1802.784790,633.710083 1785.698853,633.710083 1767.919067,633.710083
	C1762.897339,590.064697 1757.861450,546.296021 1752.693359,501.378662
	C1748.812744,507.464752 1745.336304,512.791809 1741.984619,518.196045
	C1729.348389,538.569641 1716.749512,558.966370 1704.143555,579.358826
	C1698.180908,589.004517 1692.200928,598.639832 1686.297852,608.321899
	C1684.066406,611.981812 1683.037964,612.109192 1680.955933,608.736938
	C1674.315796,597.983215 1667.652832,587.243591 1660.736328,576.232178
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M1098.120361,635.034546
	C1089.621460,636.708130 1081.582764,638.683655 1073.430176,639.890869
	C1067.421387,640.780518 1061.246704,641.143311 1055.176147,640.919739
	C1024.448486,639.788025 996.426880,631.177612 972.436462,611.039307
	C951.081909,593.113464 938.773315,570.194336 932.891724,543.270508
	C930.046936,530.248291 929.201111,517.088440 930.147400,503.970276
	C932.123962,476.568542 941.143372,451.809814 959.590637,430.843292
	C978.145630,409.754211 1001.480835,397.702850 1028.711914,391.792603
	C1043.972412,388.480438 1059.311279,388.165497 1074.516357,389.259308
	C1099.854248,391.082092 1122.650879,400.218201 1142.408936,416.732361
	C1151.843262,424.617828 1159.439087,433.818176 1166.476807,444.234863
	C1152.022705,452.627228 1137.930908,460.809143 1123.845093,468.987640
	C1120.839111,465.093781 1118.059937,461.101288 1114.887451,457.450806
	C1100.020386,440.343750 1081.135254,433.175568 1058.578979,433.829254
	C1046.929077,434.166901 1035.981567,436.248383 1025.509277,441.157013
	C1005.412903,450.576752 992.421448,466.223785 986.096985,487.281647
	C981.868347,501.361359 981.460510,515.709351 983.847900,530.335632
	C986.762146,548.190491 994.380005,563.445251 1007.406799,575.753174
	C1019.158020,586.856018 1033.234863,593.139465 1049.528198,595.160950
	C1065.606567,597.155823 1080.708862,595.041687 1095.164429,587.960022
	C1107.004883,582.159546 1115.388428,572.729248 1121.753540,561.479553
	C1124.604370,556.440857 1126.625488,550.932800 1129.324829,544.971497
	C1105.795776,544.971497 1083.105469,544.971497 1060.210327,544.971497
	C1060.210327,531.610168 1060.210327,518.666138 1060.210327,505.360596
	C1099.535522,505.360596 1138.926392,505.360596 1179.369263,505.360596
	C1178.944580,514.045654 1179.005005,522.938599 1177.941406,531.695007
	C1176.889038,540.358032 1175.126221,548.994141 1172.919434,557.444641
	C1168.896729,572.848145 1161.380371,586.552124 1151.507202,599.047913
	C1140.522339,612.950806 1126.764404,623.195740 1110.801147,630.574646
	C1106.868530,632.392334 1102.629761,633.547363 1098.120361,635.034546
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M2646.849854,634.000000
	C2630.539062,634.000000 2614.707764,634.093323 2598.880615,633.880554
	C2596.927002,633.854248 2594.180664,632.731812 2593.180908,631.210754
	C2583.930908,617.136108 2575.030762,602.832214 2565.934814,588.655518
	C2557.700439,575.822571 2549.442627,563.001770 2540.934082,550.351379
	C2539.822021,548.697876 2537.220703,547.328979 2535.192383,547.149780
	C2530.072998,546.697815 2524.886963,547.000000 2519.270752,547.000000
	C2519.270752,575.861755 2519.270752,604.590942 2519.270752,633.659180
	C2502.423096,633.659180 2486.027100,633.659180 2469.314453,633.659180
	C2469.314453,553.708923 2469.314453,473.656738 2469.314453,393.000000
	C2471.020508,393.000000 2472.785645,393.000000 2474.551025,393.000000
	C2499.045898,393.000000 2523.553711,392.524384 2548.031006,393.178986
	C2562.634277,393.569519 2577.387939,394.280396 2591.314697,399.954346
	C2615.966309,409.997772 2632.831299,426.451752 2638.147217,453.591309
	C2641.633545,471.389648 2640.073975,488.501984 2632.519775,504.680298
	C2624.602539,521.636353 2610.870117,532.947815 2593.606934,539.991516
	C2592.562012,540.417908 2591.497070,540.795593 2589.902832,541.400208
	C2611.352539,572.058472 2632.687744,602.553467 2654.688965,634.000000
	C2651.726562,634.000000 2649.528564,634.000000 2646.849854,634.000000
M2568.403076,503.004181
	C2568.877930,502.884705 2569.411865,502.867096 2569.819092,502.631104
	C2582.751465,495.141815 2588.871582,484.225403 2588.133789,468.994659
	C2587.460449,455.100983 2578.946533,444.572998 2567.245605,439.982239
	C2557.100342,436.001862 2546.485107,435.806061 2535.807129,435.983643
	C2530.231445,436.076416 2524.653076,436.000000 2519.374756,436.000000
	C2519.374756,460.136719 2519.374756,483.512207 2519.374756,506.999786
	C2530.729980,506.999786 2541.731689,507.398071 2552.682129,506.821899
	C2557.710693,506.557281 2562.638672,504.380493 2568.403076,503.004181
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M2200.441406,393.430725
	C2251.381836,393.095520 2301.978760,393.095520 2352.787354,393.095520
	C2352.787354,407.383118 2352.787354,421.325623 2352.787354,435.718567
	C2318.145264,435.718567 2283.422363,435.718567 2248.350342,435.718567
	C2248.350342,452.555115 2248.350342,468.949036 2248.350342,485.795563
	C2280.598633,485.795563 2312.989014,485.795563 2345.688721,485.795563
	C2345.688721,499.635071 2345.688721,513.029175 2345.688721,526.876221
	C2313.320068,526.876221 2280.929688,526.876221 2248.270996,526.876221
	C2248.270996,548.716431 2248.270996,570.107483 2248.270996,591.949219
	C2283.087158,591.949219 2317.810059,591.949219 2352.764893,591.949219
	C2352.764893,606.125000 2352.764893,619.851318 2352.764893,633.788940
	C2301.955566,633.788940 2251.357178,633.788940 2200.488525,633.788940
	C2200.360840,633.357361 2200.031006,632.762085 2200.031006,632.166809
	C2200.037598,552.699829 2200.068359,473.232880 2200.441406,393.430725
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M2946.720215,588.307861
	C2953.932373,603.251770 2960.920898,617.883606 2968.291016,633.314758
	C2949.072998,633.314758 2930.447510,633.314758 2911.392822,633.314758
	C2903.368164,616.060425 2895.053467,598.182617 2886.671875,580.160828
	C2859.576904,580.160828 2832.450684,580.160828 2804.983154,580.160828
	C2797.297607,597.246521 2789.630615,614.396912 2781.795898,631.470398
	C2781.272217,632.612000 2779.482910,633.881958 2778.271973,633.892334
	C2760.294434,634.047058 2742.314697,633.999146 2723.726807,633.999146
	C2724.610596,632.136658 2725.270020,630.722168 2725.949951,629.317505
	C2736.273438,607.997314 2746.640869,586.697998 2756.914307,565.353577
	C2768.306152,541.685486 2779.614990,517.977539 2790.955811,494.284882
	C2802.296143,470.592743 2813.632324,446.898651 2824.967773,423.204193
	C2831.611328,409.317688 2838.246094,395.427124 2844.898682,381.545105
	C2845.306885,380.693756 2845.838867,379.901855 2846.422119,378.894012
	C2859.395508,405.932404 2872.221680,432.680023 2885.062744,459.420410
	C2892.502441,474.913086 2899.988281,490.383575 2907.414307,505.882812
	C2918.974365,530.011902 2930.506836,554.154236 2942.035645,578.298218
	C2943.568848,581.508606 2945.011475,584.762146 2946.720215,588.307861
M2853.550781,490.045044
	C2851.208740,484.781403 2848.866699,479.517792 2846.168457,473.453400
	C2836.371338,495.926483 2826.836182,517.798401 2817.203125,539.895264
	C2836.528076,539.895264 2855.482422,539.895264 2874.821045,539.895264
	C2871.659424,532.480957 2868.549805,525.215820 2865.462402,517.941162
	C2861.613770,508.872955 2857.783691,499.796783 2853.550781,490.045044
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M2000.999390,547.000000
	C1992.528564,547.000000 1984.557739,547.000000 1976.140015,547.000000
	C1976.140015,575.996887 1976.140015,604.720154 1976.140015,633.720093
	C1959.301514,633.720093 1942.910034,633.720093 1926.258545,633.720093
	C1926.258545,553.612854 1926.258545,473.577148 1926.258545,393.197510
	C1927.583862,393.130066 1928.861572,393.008972 1930.139404,393.008362
	C1954.294189,392.997070 1978.459839,392.551331 2002.600220,393.140900
	C2022.180786,393.619080 2041.621338,395.754944 2059.113281,406.003174
	C2076.659180,416.282867 2087.795898,431.154968 2092.021484,451.146332
	C2095.232910,466.339722 2095.039307,481.431458 2090.278564,496.234222
	C2082.144287,521.526794 2063.914795,535.955322 2039.020630,543.009338
	C2026.734009,546.490906 2014.192017,547.415833 2000.999390,547.000000
M1981.609619,505.000031
	C1992.516479,504.666504 2003.496826,504.999329 2014.309082,503.807556
	C2024.630371,502.669922 2033.906128,498.545624 2040.172974,489.374390
	C2045.889526,481.008514 2045.922852,471.642181 2044.578613,462.401276
	C2043.075562,452.070435 2036.941284,444.397400 2027.074585,440.728638
	C2020.937744,438.446716 2014.354858,436.654816 2007.863037,436.198914
	C1997.342407,435.460144 1986.731934,436.000000 1976.164307,436.000000
	C1976.164307,459.283142 1976.164307,481.871460 1976.164307,504.786621
	C1977.750732,504.862305 1979.193359,504.931152 1981.609619,505.000031
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M1329.270020,527.774780
	C1302.896240,482.970978 1276.787720,438.435455 1250.151611,393.000000
	C1253.462158,393.000000 1255.713623,393.000000 1257.965088,393.000000
	C1273.297852,393.000000 1288.631592,392.919037 1303.961792,393.116364
	C1305.624268,393.137726 1308.031372,394.342407 1308.797852,395.719269
	C1315.817871,408.327637 1322.582397,421.079041 1329.360718,433.821014
	C1339.097900,452.125366 1348.784668,470.456635 1358.684204,489.137329
	C1361.555054,483.804901 1364.331909,478.702240 1367.058228,473.572601
	C1376.117065,456.527252 1385.130249,439.457458 1394.216675,422.426819
	C1399.027832,413.409210 1403.871826,404.406189 1408.924683,395.523865
	C1409.618286,394.304596 1411.602661,393.119659 1413.000122,393.106964
	C1430.825562,392.945068 1448.652954,393.000214 1467.363403,393.000214
	C1464.264893,398.608765 1461.551514,403.795044 1458.587891,408.834076
	C1448.895630,425.313141 1439.114014,441.739685 1429.363525,458.184570
	C1417.714844,477.831085 1406.052979,497.469696 1394.418945,517.124817
	C1391.119019,522.699951 1387.796509,528.266785 1384.712769,533.961121
	C1383.995972,535.284546 1384.029175,537.113525 1384.027222,538.710327
	C1383.990112,568.542480 1384.000000,598.374634 1384.000000,628.206848
	C1384.000000,629.995239 1384.000000,631.783630 1384.000000,633.782349
	C1367.289673,633.782349 1351.010376,633.782349 1334.000000,633.782349
	C1334.000000,632.123047 1334.000000,630.374695 1334.000000,628.626343
	C1334.000000,601.627380 1333.946655,574.628235 1334.036865,547.629578
	C1334.059937,540.699646 1334.578247,533.761597 1329.270020,527.774780
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M439.003448,351.960938
	C432.968292,362.542328 426.964539,372.738068 421.010834,382.962891
	C410.577698,400.880676 400.154633,418.804382 389.766602,436.748322
	C381.812592,450.487885 373.952209,464.281647 365.991272,478.017181
	C351.366943,503.249542 336.650909,528.428894 322.069702,553.686096
	C314.726593,566.405640 307.595306,579.247498 300.200653,592.330505
	C291.083832,583.721191 282.200165,575.331970 273.056580,566.697388
	C342.035156,447.139374 410.965637,327.664734 480.416962,207.287323
	C484.231445,213.717850 487.671844,219.415833 491.009460,225.173386
	C494.258484,230.778152 497.435638,236.425613 500.549835,242.106140
	C500.936218,242.810898 501.122925,244.053040 500.762665,244.677032
	C489.668579,263.893463 478.451721,283.039001 467.346039,302.248779
	C457.857513,318.661255 448.482483,335.139313 439.003448,351.960938
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M233.000000,694.000000
	C352.125488,694.000000 470.750946,694.000000 589.782288,694.000000
	C583.627625,706.050781 577.592285,717.867981 571.461304,729.872437
	C441.063843,729.872437 310.453583,729.872437 178.958023,729.872437
	C185.934067,717.753296 192.720856,705.963013 199.607040,694.000000
	C210.519882,694.000000 221.509949,694.000000 233.000000,694.000000
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M617.000488,516.003784
	C593.731812,475.590332 570.516541,435.549438 547.007507,395.001801
	C560.693237,395.001801 573.791077,394.913361 586.883789,395.131836
	C588.267395,395.154938 590.137634,396.681732 590.911072,398.015839
	C603.016541,418.897736 614.903931,439.905975 626.992676,460.797638
	C642.243408,487.153748 657.699890,513.390808 672.940430,539.752625
	C687.368774,564.709595 701.573303,589.795898 715.985535,614.762207
	C730.237488,639.450806 744.677734,664.030762 758.934448,688.716614
	C766.692749,702.150391 774.241150,715.705444 782.141541,729.660339
	C780.666992,729.788635 779.452637,729.983582 778.237915,729.986145
	C767.074890,730.009644 755.904602,729.775452 744.753235,730.135376
	C741.359741,730.244873 739.517151,728.893250 738.115967,726.452332
	C726.101135,705.523010 714.229675,684.511108 702.174561,663.605164
	C690.605896,643.542542 678.799561,623.617065 667.225769,603.557373
	C655.165527,582.654541 643.280762,561.650574 631.273376,540.717224
	C626.598083,532.566528 621.797424,524.487793 617.000488,516.003784
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M2568.007812,503.037537
	C2562.638672,504.380493 2557.710693,506.557281 2552.682129,506.821899
	C2541.731689,507.398071 2530.729980,506.999786 2519.374756,506.999786
	C2519.374756,483.512207 2519.374756,460.136719 2519.374756,436.000000
	C2524.653076,436.000000 2530.231445,436.076416 2535.807129,435.983643
	C2546.485107,435.806061 2557.100342,436.001862 2567.245605,439.982239
	C2578.946533,444.572998 2587.460449,455.100983 2588.133789,468.994659
	C2588.871582,484.225403 2582.751465,495.141815 2569.819092,502.631104
	C2569.411865,502.867096 2568.877930,502.884705 2568.007812,503.037537
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M2853.748047,490.384521
	C2857.783691,499.796783 2861.613770,508.872955 2865.462402,517.941162
	C2868.549805,525.215820 2871.659424,532.480957 2874.821045,539.895264
	C2855.482422,539.895264 2836.528076,539.895264 2817.203125,539.895264
	C2826.836182,517.798401 2836.371338,495.926483 2846.168457,473.453400
	C2848.866699,479.517792 2851.208740,484.781403 2853.748047,490.384521
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M1981.122803,505.000000
	C1979.193359,504.931152 1977.750732,504.862305 1976.164307,504.786621
	C1976.164307,481.871460 1976.164307,459.283142 1976.164307,436.000000
	C1986.731934,436.000000 1997.342407,435.460144 2007.863037,436.198914
	C2014.354858,436.654816 2020.937744,438.446716 2027.074585,440.728638
	C2036.941284,444.397400 2043.075562,452.070435 2044.578613,462.401276
	C2045.922852,471.642181 2045.889526,481.008514 2040.172974,489.374390
	C2033.906128,498.545624 2024.630371,502.669922 2014.309082,503.807556
	C2003.496826,504.999329 1992.516479,504.666504 1981.122803,505.000000
z"
      />
    </Svg>
  );
};

const Admin: FC<Omit<SvgProps, 'children'>> = (props) => {
  return (
    <Svg viewBox="0 0 3078 897" {...props}>
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M2139.000000,898.000000
	C1426.000000,898.000000 713.500000,898.000000 1.000000,898.000000
	C1.000000,599.000000 1.000000,300.000000 1.000000,1.000000
	C1027.000000,1.000000 2053.000000,1.000000 3079.000000,1.000000
	C3079.000000,300.000000 3079.000000,599.000000 3079.000000,898.000000
	C2765.833252,898.000000 2452.666748,898.000000 2139.000000,898.000000
M232.537964,558.956177
	C230.687332,562.004944 228.984833,565.157104 226.947525,568.075562
	C224.552597,571.506287 225.134064,573.826843 228.167648,576.826172
	C252.937515,601.315979 277.500000,626.015381 302.157532,650.619019
	C303.383667,651.842468 304.906006,652.769043 306.290436,653.833862
	C305.995636,654.222595 305.700836,654.611267 305.406036,655.000000
	C303.787231,655.000000 302.168427,655.000000 300.549622,655.000000
	C260.549835,655.000000 220.550003,654.978149 180.550491,655.078369
	C178.915436,655.082458 176.465897,655.752441 175.772568,656.925720
	C165.638519,674.075439 155.766891,691.379883 145.775360,708.614258
	C137.321869,723.195557 128.750244,737.708496 120.323067,752.304871
	C117.291725,757.555298 114.529167,762.960815 111.262970,769.000000
	C114.209076,769.000000 116.173798,769.000000 118.138527,769.000000
	C274.304321,769.000000 430.470215,768.943726 586.635620,769.193726
	C593.281250,769.204407 596.489136,767.026367 599.300171,761.451233
	C610.264282,739.706238 621.525085,718.108643 632.899414,696.574402
	C635.441833,691.761230 636.692566,687.581787 632.610474,683.011414
	C631.030151,681.242004 630.177368,678.829163 628.959229,676.729126
	C613.997192,650.935303 598.957581,625.186218 584.081848,599.342834
	C568.497925,572.269043 553.069763,545.105591 537.584290,518.000122
	C507.634003,518.000122 477.971924,517.952209 448.311188,518.130188
	C446.691315,518.139893 444.476807,519.656250 443.568085,521.113098
	C437.997223,530.044189 432.665405,539.126831 427.374298,548.228943
	C424.675018,552.872559 422.226349,557.661865 419.330994,563.000000
	C422.194702,563.000000 424.016449,563.000000 425.838196,563.000000
	C451.171387,563.000000 476.504730,562.964355 501.837402,563.079590
	C503.544891,563.087341 506.095642,563.724976 506.818115,564.930359
	C512.732605,574.798279 518.251770,584.902039 523.995972,594.873596
	C532.081726,608.909790 540.291504,622.874451 548.378418,636.910034
	C551.727539,642.722778 554.895813,648.639771 558.360535,654.896118
	C474.944061,654.896118 392.286377,654.896118 308.820862,654.896118
	C366.012115,556.011230 423.005432,457.468445 480.472900,358.105957
	C491.822693,377.690155 502.587585,396.153381 513.242432,414.679840
	C525.277588,435.606354 537.139221,456.632843 549.214661,477.535919
	C560.723328,497.457855 572.496460,517.227051 583.995178,537.154663
	C596.139832,558.201721 608.008057,579.408447 620.161621,600.450256
	C633.292786,623.184509 646.657532,645.783813 659.836975,668.490417
	C667.886536,682.358765 675.732117,696.345520 683.753479,710.230347
	C694.127075,728.186829 704.686096,746.037109 714.915344,764.074951
	C716.829773,767.450928 718.648499,769.121704 722.817993,769.104126
	C763.650391,768.931396 804.483765,769.000000 845.316895,769.000000
	C846.706970,769.000000 848.097046,769.000000 849.977112,769.000000
	C846.383179,762.438416 843.246948,756.421753 839.848022,750.557434
	C825.383545,725.601929 810.784302,700.724487 796.345276,675.754272
	C784.750610,655.702881 773.387146,635.517822 761.791809,615.466858
	C747.352051,590.497253 732.764709,565.612976 718.269836,540.675232
	C710.048706,526.531189 701.886414,512.352966 693.695312,498.191467
	C683.473022,480.518372 673.231140,462.856628 663.030029,445.171326
	C654.612549,430.578247 646.256226,415.949951 637.846741,401.352264
	C629.919250,387.591339 621.756775,373.959595 614.162415,360.017792
	C612.415649,356.811096 610.730713,355.932220 607.390442,355.939972
	C567.390869,356.032867 527.390991,356.000000 487.391235,356.000000
	C485.785370,356.000000 484.179535,356.000000 482.128357,356.000000
	C482.817383,354.597351 483.260712,353.562653 483.813263,352.590027
	C491.653809,338.788666 499.424835,324.946808 507.380402,311.211884
	C519.966675,289.482178 532.716187,267.846863 545.245972,246.084839
	C545.999756,244.775589 546.087402,242.333252 545.367432,241.040619
	C537.959351,227.740097 530.353577,214.549042 522.738831,201.364456
	C509.451569,178.358017 496.125641,155.373856 482.781647,132.400284
	C482.261108,131.504089 481.387207,130.813171 480.677979,130.026566
	C479.819489,130.849823 478.712738,131.530228 478.143311,132.519821
	C474.751740,138.413849 471.550385,144.417282 468.162567,150.313538
	C458.800964,166.606689 449.396576,182.875366 439.975159,199.134079
	C431.932709,213.013092 423.803741,226.842056 415.785004,240.734680
	C406.472473,256.868805 397.240723,273.049591 387.969635,289.207642
	C379.743469,303.544556 371.538513,317.893768 363.274750,332.209015
	C353.879120,348.484924 344.398682,364.711853 335.010437,380.992004
	C325.783447,396.992371 316.651123,413.047241 307.430847,429.051453
	C297.970734,445.472015 288.465820,461.866730 278.958923,478.260254
	C271.886108,490.456451 264.722351,502.600250 257.701508,514.826172
	C249.393768,529.292969 241.196045,543.822937 232.537964,558.956177
M1660.998657,576.498535
	C1667.652832,587.243591 1674.315796,597.983215 1680.955933,608.736938
	C1683.037964,612.109192 1684.066406,611.981812 1686.297852,608.321899
	C1692.200928,598.639832 1698.180908,589.004517 1704.143555,579.358826
	C1716.749512,558.966370 1729.348389,538.569641 1741.984619,518.196045
	C1745.336304,512.791809 1748.812744,507.464752 1752.693359,501.378662
	C1757.861450,546.296021 1762.897339,590.064697 1767.919067,633.710083
	C1785.698853,633.710083 1802.784790,633.710083 1820.041382,633.710083
	C1808.107178,549.385986 1796.216553,465.370667 1784.168701,380.244446
	C1750.210449,432.618225 1717.005249,483.830383 1683.538086,535.446533
	C1649.757568,483.948792 1616.976807,432.501556 1583.468018,381.537811
	C1583.137207,381.822754 1582.806396,382.107697 1582.475708,382.392639
	C1570.631958,466.102142 1558.788086,549.811646 1546.906982,633.785156
	C1564.395752,633.785156 1581.494507,633.785156 1599.032593,633.785156
	C1604.025269,590.479675 1609.006226,547.276855 1613.987183,504.074097
	C1614.414062,503.960144 1614.840942,503.846161 1615.267700,503.732178
	C1616.195679,504.934662 1617.226318,506.072113 1618.035645,507.349762
	C1625.670044,519.402405 1633.344238,531.431030 1640.851196,543.562988
	C1647.494995,554.300232 1653.940674,565.160095 1660.998657,576.498535
M1098.531738,635.006958
	C1102.629761,633.547363 1106.868530,632.392334 1110.801147,630.574646
	C1126.764404,623.195740 1140.522339,612.950806 1151.507202,599.047913
	C1161.380371,586.552124 1168.896729,572.848145 1172.919434,557.444641
	C1175.126221,548.994141 1176.889038,540.358032 1177.941406,531.695007
	C1179.005005,522.938599 1178.944580,514.045654 1179.369263,505.360596
	C1138.926392,505.360596 1099.535522,505.360596 1060.210327,505.360596
	C1060.210327,518.666138 1060.210327,531.610168 1060.210327,544.971497
	C1083.105469,544.971497 1105.795776,544.971497 1129.324829,544.971497
	C1126.625488,550.932800 1124.604370,556.440857 1121.753540,561.479553
	C1115.388428,572.729248 1107.004883,582.159546 1095.164429,587.960022
	C1080.708862,595.041687 1065.606567,597.155823 1049.528198,595.160950
	C1033.234863,593.139465 1019.158020,586.856018 1007.406799,575.753174
	C994.380005,563.445251 986.762146,548.190491 983.847900,530.335632
	C981.460510,515.709351 981.868347,501.361359 986.096985,487.281647
	C992.421448,466.223785 1005.412903,450.576752 1025.509277,441.157013
	C1035.981567,436.248383 1046.929077,434.166901 1058.578979,433.829254
	C1081.135254,433.175568 1100.020386,440.343750 1114.887451,457.450806
	C1118.059937,461.101288 1120.839111,465.093781 1123.845093,468.987640
	C1137.930908,460.809143 1152.022705,452.627228 1166.476807,444.234863
	C1159.439087,433.818176 1151.843262,424.617828 1142.408936,416.732361
	C1122.650879,400.218201 1099.854248,391.082092 1074.516357,389.259308
	C1059.311279,388.165497 1043.972412,388.480438 1028.711914,391.792603
	C1001.480835,397.702850 978.145630,409.754211 959.590637,430.843292
	C941.143372,451.809814 932.123962,476.568542 930.147400,503.970276
	C929.201111,517.088440 930.046936,530.248291 932.891724,543.270508
	C938.773315,570.194336 951.081909,593.113464 972.436462,611.039307
	C996.426880,631.177612 1024.448486,639.788025 1055.176147,640.919739
	C1061.246704,641.143311 1067.421387,640.780518 1073.430176,639.890869
	C1081.582764,638.683655 1089.621460,636.708130 1098.531738,635.006958
M2647.330566,634.000000
	C2649.528564,634.000000 2651.726562,634.000000 2654.688965,634.000000
	C2632.687744,602.553467 2611.352539,572.058472 2589.902832,541.400208
	C2591.497070,540.795593 2592.562012,540.417908 2593.606934,539.991516
	C2610.870117,532.947815 2624.602539,521.636353 2632.519775,504.680298
	C2640.073975,488.501984 2641.633545,471.389648 2638.147217,453.591309
	C2632.831299,426.451752 2615.966309,409.997772 2591.314697,399.954346
	C2577.387939,394.280396 2562.634277,393.569519 2548.031006,393.178986
	C2523.553711,392.524384 2499.045898,393.000000 2474.551025,393.000000
	C2472.785645,393.000000 2471.020508,393.000000 2469.314453,393.000000
	C2469.314453,473.656738 2469.314453,553.708923 2469.314453,633.659180
	C2486.027100,633.659180 2502.423096,633.659180 2519.270752,633.659180
	C2519.270752,604.590942 2519.270752,575.861755 2519.270752,547.000000
	C2524.886963,547.000000 2530.072998,546.697815 2535.192383,547.149780
	C2537.220703,547.328979 2539.822021,548.697876 2540.934082,550.351379
	C2549.442627,563.001770 2557.700439,575.822571 2565.934814,588.655518
	C2575.030762,602.832214 2583.930908,617.136108 2593.180908,631.210754
	C2594.180664,632.731812 2596.927002,633.854248 2598.880615,633.880554
	C2614.707764,634.093323 2630.539062,634.000000 2647.330566,634.000000
M2200.097900,393.765900
	C2200.068359,473.232880 2200.037598,552.699829 2200.031006,632.166809
	C2200.031006,632.762085 2200.360840,633.357361 2200.488525,633.788940
	C2251.357178,633.788940 2301.955566,633.788940 2352.764893,633.788940
	C2352.764893,619.851318 2352.764893,606.125000 2352.764893,591.949219
	C2317.810059,591.949219 2283.087158,591.949219 2248.270996,591.949219
	C2248.270996,570.107483 2248.270996,548.716431 2248.270996,526.876221
	C2280.929688,526.876221 2313.320068,526.876221 2345.688721,526.876221
	C2345.688721,513.029175 2345.688721,499.635071 2345.688721,485.795563
	C2312.989014,485.795563 2280.598633,485.795563 2248.350342,485.795563
	C2248.350342,468.949036 2248.350342,452.555115 2248.350342,435.718567
	C2283.422363,435.718567 2318.145264,435.718567 2352.787354,435.718567
	C2352.787354,421.325623 2352.787354,407.383118 2352.787354,393.095520
	C2301.978760,393.095520 2251.381836,393.095520 2200.097900,393.765900
M2946.496094,587.995667
	C2945.011475,584.762146 2943.568848,581.508606 2942.035645,578.298218
	C2930.506836,554.154236 2918.974365,530.011902 2907.414307,505.882812
	C2899.988281,490.383575 2892.502441,474.913086 2885.062744,459.420410
	C2872.221680,432.680023 2859.395508,405.932404 2846.422119,378.894012
	C2845.838867,379.901855 2845.306885,380.693756 2844.898682,381.545105
	C2838.246094,395.427124 2831.611328,409.317688 2824.967773,423.204193
	C2813.632324,446.898651 2802.296143,470.592743 2790.955811,494.284882
	C2779.614990,517.977539 2768.306152,541.685486 2756.914307,565.353577
	C2746.640869,586.697998 2736.273438,607.997314 2725.949951,629.317505
	C2725.270020,630.722168 2724.610596,632.136658 2723.726807,633.999146
	C2742.314697,633.999146 2760.294434,634.047058 2778.271973,633.892334
	C2779.482910,633.881958 2781.272217,632.612000 2781.795898,631.470398
	C2789.630615,614.396912 2797.297607,597.246521 2804.983154,580.160828
	C2832.450684,580.160828 2859.576904,580.160828 2886.671875,580.160828
	C2895.053467,598.182617 2903.368164,616.060425 2911.392822,633.314758
	C2930.447510,633.314758 2949.072998,633.314758 2968.291016,633.314758
	C2960.920898,617.883606 2953.932373,603.251770 2946.496094,587.995667
M2001.499268,547.000000
	C2014.192017,547.415833 2026.734009,546.490906 2039.020630,543.009338
	C2063.914795,535.955322 2082.144287,521.526794 2090.278564,496.234222
	C2095.039307,481.431458 2095.232910,466.339722 2092.021484,451.146332
	C2087.795898,431.154968 2076.659180,416.282867 2059.113281,406.003174
	C2041.621338,395.754944 2022.180786,393.619080 2002.600220,393.140900
	C1978.459839,392.551331 1954.294189,392.997070 1930.139404,393.008362
	C1928.861572,393.008972 1927.583862,393.130066 1926.258545,393.197510
	C1926.258545,473.577148 1926.258545,553.612854 1926.258545,633.720093
	C1942.910034,633.720093 1959.301514,633.720093 1976.140015,633.720093
	C1976.140015,604.720154 1976.140015,575.996887 1976.140015,547.000000
	C1984.557739,547.000000 1992.528564,547.000000 2001.499268,547.000000
M1329.535400,528.043091
	C1334.578247,533.761597 1334.059937,540.699646 1334.036865,547.629578
	C1333.946655,574.628235 1334.000000,601.627380 1334.000000,628.626343
	C1334.000000,630.374695 1334.000000,632.123047 1334.000000,633.782349
	C1351.010376,633.782349 1367.289673,633.782349 1384.000000,633.782349
	C1384.000000,631.783630 1384.000000,629.995239 1384.000000,628.206848
	C1384.000000,598.374634 1383.990112,568.542480 1384.027222,538.710327
	C1384.029175,537.113525 1383.995972,535.284546 1384.712769,533.961121
	C1387.796509,528.266785 1391.119019,522.699951 1394.418945,517.124817
	C1406.052979,497.469696 1417.714844,477.831085 1429.363525,458.184570
	C1439.114014,441.739685 1448.895630,425.313141 1458.587891,408.834076
	C1461.551514,403.795044 1464.264893,398.608765 1467.363403,393.000214
	C1448.652954,393.000214 1430.825562,392.945068 1413.000122,393.106964
	C1411.602661,393.119659 1409.618286,394.304596 1408.924683,395.523865
	C1403.871826,404.406189 1399.027832,413.409210 1394.216675,422.426819
	C1385.130249,439.457458 1376.117065,456.527252 1367.058228,473.572601
	C1364.331909,478.702240 1361.555054,483.804901 1358.684204,489.137329
	C1348.784668,470.456635 1339.097900,452.125366 1329.360718,433.821014
	C1322.582397,421.079041 1315.817871,408.327637 1308.797852,395.719269
	C1308.031372,394.342407 1305.624268,393.137726 1303.961792,393.116364
	C1288.631592,392.919037 1273.297852,393.000000 1257.965088,393.000000
	C1255.713623,393.000000 1253.462158,393.000000 1250.151611,393.000000
	C1276.787720,438.435455 1302.896240,482.970978 1329.535400,528.043091
z"
      />
      <path
        fill="#336633"
        opacity="1.000000"
        stroke="none"
        d="
M232.744308,558.640869
	C241.196045,543.822937 249.393768,529.292969 257.701508,514.826172
	C264.722351,502.600250 271.886108,490.456451 278.958923,478.260254
	C288.465820,461.866730 297.970734,445.472015 307.430847,429.051453
	C316.651123,413.047241 325.783447,396.992371 335.010437,380.992004
	C344.398682,364.711853 353.879120,348.484924 363.274750,332.209015
	C371.538513,317.893768 379.743469,303.544556 387.969635,289.207642
	C397.240723,273.049591 406.472473,256.868805 415.785004,240.734680
	C423.803741,226.842056 431.932709,213.013092 439.975159,199.134079
	C449.396576,182.875366 458.800964,166.606689 468.162567,150.313538
	C471.550385,144.417282 474.751740,138.413849 478.143311,132.519821
	C478.712738,131.530228 479.819489,130.849823 480.677979,130.026581
	C481.387207,130.813171 482.261108,131.504089 482.781647,132.400284
	C496.125641,155.373856 509.451569,178.358017 522.738831,201.364456
	C530.353577,214.549042 537.959351,227.740097 545.367432,241.040619
	C546.087402,242.333252 545.999756,244.775589 545.245972,246.084839
	C532.716187,267.846863 519.966675,289.482178 507.380402,311.211884
	C499.424835,324.946808 491.653809,338.788666 483.813263,352.590027
	C483.260712,353.562653 482.817383,354.597351 482.128357,356.000000
	C484.179535,356.000000 485.785370,356.000000 487.391235,356.000000
	C527.390991,356.000000 567.390869,356.032867 607.390442,355.939972
	C610.730713,355.932220 612.415649,356.811096 614.162415,360.017792
	C621.756775,373.959595 629.919250,387.591339 637.846741,401.352264
	C646.256226,415.949951 654.612549,430.578247 663.030029,445.171326
	C673.231140,462.856628 683.473022,480.518372 693.695312,498.191467
	C701.886414,512.352966 710.048706,526.531189 718.269836,540.675232
	C732.764709,565.612976 747.352051,590.497253 761.791809,615.466858
	C773.387146,635.517822 784.750610,655.702881 796.345276,675.754272
	C810.784302,700.724487 825.383545,725.601929 839.848022,750.557434
	C843.246948,756.421753 846.383179,762.438416 849.977112,769.000000
	C848.097046,769.000000 846.706970,769.000000 845.316895,769.000000
	C804.483765,769.000000 763.650391,768.931396 722.817993,769.104126
	C718.648499,769.121704 716.829773,767.450928 714.915344,764.074951
	C704.686096,746.037109 694.127075,728.186829 683.753479,710.230347
	C675.732117,696.345520 667.886536,682.358765 659.836975,668.490417
	C646.657532,645.783813 633.292786,623.184509 620.161621,600.450256
	C608.008057,579.408447 596.139832,558.201721 583.995178,537.154663
	C572.496460,517.227051 560.723328,497.457855 549.214661,477.535919
	C537.139221,456.632843 525.277588,435.606354 513.242432,414.679840
	C502.587585,396.153381 491.822693,377.690155 480.472900,358.105957
	C423.005432,457.468445 366.012115,556.011230 308.820862,654.896118
	C392.286377,654.896118 474.944061,654.896118 558.360535,654.896118
	C554.895813,648.639771 551.727539,642.722778 548.378418,636.910034
	C540.291504,622.874451 532.081726,608.909790 523.995972,594.873596
	C518.251770,584.902039 512.732605,574.798279 506.818115,564.930359
	C506.095642,563.724976 503.544891,563.087341 501.837402,563.079590
	C476.504730,562.964355 451.171387,563.000000 425.838196,563.000000
	C424.016449,563.000000 422.194702,563.000000 419.330994,563.000000
	C422.226349,557.661865 424.675018,552.872559 427.374298,548.228943
	C432.665405,539.126831 437.997223,530.044189 443.568085,521.113098
	C444.476807,519.656250 446.691315,518.139893 448.311188,518.130188
	C477.971924,517.952209 507.634003,518.000122 537.584290,518.000122
	C553.069763,545.105591 568.497925,572.269043 584.081848,599.342834
	C598.957581,625.186218 613.997192,650.935303 628.959229,676.729126
	C630.177368,678.829163 631.030151,681.242004 632.610474,683.011414
	C636.692566,687.581787 635.441833,691.761230 632.899414,696.574402
	C621.525085,718.108643 610.264282,739.706238 599.300171,761.451233
	C596.489136,767.026367 593.281250,769.204407 586.635620,769.193726
	C430.470215,768.943726 274.304321,769.000000 118.138527,769.000000
	C116.173798,769.000000 114.209076,769.000000 111.262970,769.000000
	C114.529167,762.960815 117.291725,757.555298 120.323067,752.304871
	C128.750244,737.708496 137.321869,723.195557 145.775360,708.614258
	C155.766891,691.379883 165.638519,674.075439 175.772568,656.925720
	C176.465897,655.752441 178.915436,655.082458 180.550491,655.078369
	C220.550003,654.978149 260.549835,655.000000 300.549622,655.000000
	C302.168427,655.000000 303.787231,655.000000 305.406036,655.000000
	C305.700836,654.611267 305.995636,654.222595 306.290436,653.833862
	C304.906006,652.769043 303.383667,651.842468 302.157532,650.619019
	C277.500000,626.015381 252.937515,601.315979 228.167648,576.826172
	C225.134064,573.826843 224.552597,571.506287 226.947525,568.075562
	C228.984833,565.157104 230.687332,562.004944 232.744308,558.640869
M439.057343,351.588379
	C448.482483,335.139313 457.857513,318.661255 467.346039,302.248779
	C478.451721,283.039001 489.668579,263.893463 500.762665,244.677032
	C501.122925,244.053040 500.936218,242.810898 500.549835,242.106140
	C497.435638,236.425613 494.258484,230.778152 491.009460,225.173386
	C487.671844,219.415833 484.231445,213.717850 480.416962,207.287323
	C410.965637,327.664734 342.035156,447.139374 273.056580,566.697388
	C282.200165,575.331970 291.083832,583.721191 300.200653,592.330505
	C307.595306,579.247498 314.726593,566.405640 322.069702,553.686096
	C336.650909,528.428894 351.366943,503.249542 365.991272,478.017181
	C373.952209,464.281647 381.812592,450.487885 389.766602,436.748322
	C400.154633,418.804382 410.577698,400.880676 421.010834,382.962891
	C426.964539,372.738068 432.968292,362.542328 439.057343,351.588379
M232.500000,694.000000
	C221.509949,694.000000 210.519882,694.000000 199.607040,694.000000
	C192.720856,705.963013 185.934067,717.753296 178.958023,729.872437
	C310.453583,729.872437 441.063843,729.872437 571.461304,729.872437
	C577.592285,717.867981 583.627625,706.050781 589.782288,694.000000
	C470.750946,694.000000 352.125488,694.000000 232.500000,694.000000
M617.053833,516.376282
	C621.797424,524.487793 626.598083,532.566528 631.273376,540.717224
	C643.280762,561.650574 655.165527,582.654541 667.225769,603.557373
	C678.799561,623.617065 690.605896,643.542542 702.174561,663.605164
	C714.229675,684.511108 726.101135,705.523010 738.115967,726.452332
	C739.517151,728.893250 741.359741,730.244873 744.753235,730.135376
	C755.904602,729.775452 767.074890,730.009644 778.237915,729.986145
	C779.452637,729.983582 780.666992,729.788635 782.141541,729.660339
	C774.241150,715.705444 766.692749,702.150391 758.934448,688.716614
	C744.677734,664.030762 730.237488,639.450806 715.985535,614.762207
	C701.573303,589.795898 687.368774,564.709595 672.940430,539.752625
	C657.699890,513.390808 642.243408,487.153748 626.992676,460.797638
	C614.903931,439.905975 603.016541,418.897736 590.911072,398.015839
	C590.137634,396.681732 588.267395,395.154938 586.883789,395.131836
	C573.791077,394.913361 560.693237,395.001801 547.007507,395.001801
	C570.516541,435.549438 593.731812,475.590332 617.053833,516.376282
z"
      />
      <path
        fill="#336633"
        opacity="1.000000"
        stroke="none"
        d="
M1660.736328,576.232178
	C1653.940674,565.160095 1647.494995,554.300232 1640.851196,543.562988
	C1633.344238,531.431030 1625.670044,519.402405 1618.035645,507.349762
	C1617.226318,506.072113 1616.195679,504.934662 1615.267700,503.732178
	C1614.840942,503.846161 1614.414062,503.960144 1613.987183,504.074097
	C1609.006226,547.276855 1604.025269,590.479675 1599.032593,633.785156
	C1581.494507,633.785156 1564.395752,633.785156 1546.906982,633.785156
	C1558.788086,549.811646 1570.631958,466.102142 1582.475708,382.392639
	C1582.806396,382.107697 1583.137207,381.822754 1583.468018,381.537811
	C1616.976807,432.501556 1649.757568,483.948792 1683.538086,535.446533
	C1717.005249,483.830383 1750.210449,432.618225 1784.168701,380.244446
	C1796.216553,465.370667 1808.107178,549.385986 1820.041382,633.710083
	C1802.784790,633.710083 1785.698853,633.710083 1767.919067,633.710083
	C1762.897339,590.064697 1757.861450,546.296021 1752.693359,501.378662
	C1748.812744,507.464752 1745.336304,512.791809 1741.984619,518.196045
	C1729.348389,538.569641 1716.749512,558.966370 1704.143555,579.358826
	C1698.180908,589.004517 1692.200928,598.639832 1686.297852,608.321899
	C1684.066406,611.981812 1683.037964,612.109192 1680.955933,608.736938
	C1674.315796,597.983215 1667.652832,587.243591 1660.736328,576.232178
z"
      />
      <path
        fill="#336633"
        opacity="1.000000"
        stroke="none"
        d="
M1098.120361,635.034546
	C1089.621460,636.708130 1081.582764,638.683655 1073.430176,639.890869
	C1067.421387,640.780518 1061.246704,641.143311 1055.176147,640.919739
	C1024.448486,639.788025 996.426880,631.177612 972.436462,611.039307
	C951.081909,593.113464 938.773315,570.194336 932.891724,543.270508
	C930.046936,530.248291 929.201111,517.088440 930.147400,503.970276
	C932.123962,476.568542 941.143372,451.809814 959.590637,430.843292
	C978.145630,409.754211 1001.480835,397.702850 1028.711914,391.792603
	C1043.972412,388.480438 1059.311279,388.165497 1074.516357,389.259308
	C1099.854248,391.082092 1122.650879,400.218201 1142.408936,416.732361
	C1151.843262,424.617828 1159.439087,433.818176 1166.476807,444.234863
	C1152.022705,452.627228 1137.930908,460.809143 1123.845093,468.987640
	C1120.839111,465.093781 1118.059937,461.101288 1114.887451,457.450806
	C1100.020386,440.343750 1081.135254,433.175568 1058.578979,433.829254
	C1046.929077,434.166901 1035.981567,436.248383 1025.509277,441.157013
	C1005.412903,450.576752 992.421448,466.223785 986.096985,487.281647
	C981.868347,501.361359 981.460510,515.709351 983.847900,530.335632
	C986.762146,548.190491 994.380005,563.445251 1007.406799,575.753174
	C1019.158020,586.856018 1033.234863,593.139465 1049.528198,595.160950
	C1065.606567,597.155823 1080.708862,595.041687 1095.164429,587.960022
	C1107.004883,582.159546 1115.388428,572.729248 1121.753540,561.479553
	C1124.604370,556.440857 1126.625488,550.932800 1129.324829,544.971497
	C1105.795776,544.971497 1083.105469,544.971497 1060.210327,544.971497
	C1060.210327,531.610168 1060.210327,518.666138 1060.210327,505.360596
	C1099.535522,505.360596 1138.926392,505.360596 1179.369263,505.360596
	C1178.944580,514.045654 1179.005005,522.938599 1177.941406,531.695007
	C1176.889038,540.358032 1175.126221,548.994141 1172.919434,557.444641
	C1168.896729,572.848145 1161.380371,586.552124 1151.507202,599.047913
	C1140.522339,612.950806 1126.764404,623.195740 1110.801147,630.574646
	C1106.868530,632.392334 1102.629761,633.547363 1098.120361,635.034546
z"
      />
      <path
        fill="#336633"
        opacity="1.000000"
        stroke="none"
        d="
M2646.849854,634.000000
	C2630.539062,634.000000 2614.707764,634.093323 2598.880615,633.880554
	C2596.927002,633.854248 2594.180664,632.731812 2593.180908,631.210754
	C2583.930908,617.136108 2575.030762,602.832214 2565.934814,588.655518
	C2557.700439,575.822571 2549.442627,563.001770 2540.934082,550.351379
	C2539.822021,548.697876 2537.220703,547.328979 2535.192383,547.149780
	C2530.072998,546.697815 2524.886963,547.000000 2519.270752,547.000000
	C2519.270752,575.861755 2519.270752,604.590942 2519.270752,633.659180
	C2502.423096,633.659180 2486.027100,633.659180 2469.314453,633.659180
	C2469.314453,553.708923 2469.314453,473.656738 2469.314453,393.000000
	C2471.020508,393.000000 2472.785645,393.000000 2474.551025,393.000000
	C2499.045898,393.000000 2523.553711,392.524384 2548.031006,393.178986
	C2562.634277,393.569519 2577.387939,394.280396 2591.314697,399.954346
	C2615.966309,409.997772 2632.831299,426.451752 2638.147217,453.591309
	C2641.633545,471.389648 2640.073975,488.501984 2632.519775,504.680298
	C2624.602539,521.636353 2610.870117,532.947815 2593.606934,539.991516
	C2592.562012,540.417908 2591.497070,540.795593 2589.902832,541.400208
	C2611.352539,572.058472 2632.687744,602.553467 2654.688965,634.000000
	C2651.726562,634.000000 2649.528564,634.000000 2646.849854,634.000000
M2568.403076,503.004181
	C2568.877930,502.884705 2569.411865,502.867096 2569.819092,502.631104
	C2582.751465,495.141815 2588.871582,484.225403 2588.133789,468.994659
	C2587.460449,455.100983 2578.946533,444.572998 2567.245605,439.982239
	C2557.100342,436.001862 2546.485107,435.806061 2535.807129,435.983643
	C2530.231445,436.076416 2524.653076,436.000000 2519.374756,436.000000
	C2519.374756,460.136719 2519.374756,483.512207 2519.374756,506.999786
	C2530.729980,506.999786 2541.731689,507.398071 2552.682129,506.821899
	C2557.710693,506.557281 2562.638672,504.380493 2568.403076,503.004181
z"
      />
      <path
        fill="#336633"
        opacity="1.000000"
        stroke="none"
        d="
M2200.441406,393.430725
	C2251.381836,393.095520 2301.978760,393.095520 2352.787354,393.095520
	C2352.787354,407.383118 2352.787354,421.325623 2352.787354,435.718567
	C2318.145264,435.718567 2283.422363,435.718567 2248.350342,435.718567
	C2248.350342,452.555115 2248.350342,468.949036 2248.350342,485.795563
	C2280.598633,485.795563 2312.989014,485.795563 2345.688721,485.795563
	C2345.688721,499.635071 2345.688721,513.029175 2345.688721,526.876221
	C2313.320068,526.876221 2280.929688,526.876221 2248.270996,526.876221
	C2248.270996,548.716431 2248.270996,570.107483 2248.270996,591.949219
	C2283.087158,591.949219 2317.810059,591.949219 2352.764893,591.949219
	C2352.764893,606.125000 2352.764893,619.851318 2352.764893,633.788940
	C2301.955566,633.788940 2251.357178,633.788940 2200.488525,633.788940
	C2200.360840,633.357361 2200.031006,632.762085 2200.031006,632.166809
	C2200.037598,552.699829 2200.068359,473.232880 2200.441406,393.430725
z"
      />
      <path
        fill="#336633"
        opacity="1.000000"
        stroke="none"
        d="
M2946.720215,588.307861
	C2953.932373,603.251770 2960.920898,617.883606 2968.291016,633.314758
	C2949.072998,633.314758 2930.447510,633.314758 2911.392822,633.314758
	C2903.368164,616.060425 2895.053467,598.182617 2886.671875,580.160828
	C2859.576904,580.160828 2832.450684,580.160828 2804.983154,580.160828
	C2797.297607,597.246521 2789.630615,614.396912 2781.795898,631.470398
	C2781.272217,632.612000 2779.482910,633.881958 2778.271973,633.892334
	C2760.294434,634.047058 2742.314697,633.999146 2723.726807,633.999146
	C2724.610596,632.136658 2725.270020,630.722168 2725.949951,629.317505
	C2736.273438,607.997314 2746.640869,586.697998 2756.914307,565.353577
	C2768.306152,541.685486 2779.614990,517.977539 2790.955811,494.284882
	C2802.296143,470.592743 2813.632324,446.898651 2824.967773,423.204193
	C2831.611328,409.317688 2838.246094,395.427124 2844.898682,381.545105
	C2845.306885,380.693756 2845.838867,379.901855 2846.422119,378.894012
	C2859.395508,405.932404 2872.221680,432.680023 2885.062744,459.420410
	C2892.502441,474.913086 2899.988281,490.383575 2907.414307,505.882812
	C2918.974365,530.011902 2930.506836,554.154236 2942.035645,578.298218
	C2943.568848,581.508606 2945.011475,584.762146 2946.720215,588.307861
M2853.550781,490.045044
	C2851.208740,484.781403 2848.866699,479.517792 2846.168457,473.453400
	C2836.371338,495.926483 2826.836182,517.798401 2817.203125,539.895264
	C2836.528076,539.895264 2855.482422,539.895264 2874.821045,539.895264
	C2871.659424,532.480957 2868.549805,525.215820 2865.462402,517.941162
	C2861.613770,508.872955 2857.783691,499.796783 2853.550781,490.045044
z"
      />
      <path
        fill="#336633"
        opacity="1.000000"
        stroke="none"
        d="
M2000.999390,547.000000
	C1992.528564,547.000000 1984.557739,547.000000 1976.140015,547.000000
	C1976.140015,575.996887 1976.140015,604.720154 1976.140015,633.720093
	C1959.301514,633.720093 1942.910034,633.720093 1926.258545,633.720093
	C1926.258545,553.612854 1926.258545,473.577148 1926.258545,393.197510
	C1927.583862,393.130066 1928.861572,393.008972 1930.139404,393.008362
	C1954.294189,392.997070 1978.459839,392.551331 2002.600220,393.140900
	C2022.180786,393.619080 2041.621338,395.754944 2059.113281,406.003174
	C2076.659180,416.282867 2087.795898,431.154968 2092.021484,451.146332
	C2095.232910,466.339722 2095.039307,481.431458 2090.278564,496.234222
	C2082.144287,521.526794 2063.914795,535.955322 2039.020630,543.009338
	C2026.734009,546.490906 2014.192017,547.415833 2000.999390,547.000000
M1981.609619,505.000031
	C1992.516479,504.666504 2003.496826,504.999329 2014.309082,503.807556
	C2024.630371,502.669922 2033.906128,498.545624 2040.172974,489.374390
	C2045.889526,481.008514 2045.922852,471.642181 2044.578613,462.401276
	C2043.075562,452.070435 2036.941284,444.397400 2027.074585,440.728638
	C2020.937744,438.446716 2014.354858,436.654816 2007.863037,436.198914
	C1997.342407,435.460144 1986.731934,436.000000 1976.164307,436.000000
	C1976.164307,459.283142 1976.164307,481.871460 1976.164307,504.786621
	C1977.750732,504.862305 1979.193359,504.931152 1981.609619,505.000031
z"
      />
      <path
        fill="#336633"
        opacity="1.000000"
        stroke="none"
        d="
M1329.270020,527.774780
	C1302.896240,482.970978 1276.787720,438.435455 1250.151611,393.000000
	C1253.462158,393.000000 1255.713623,393.000000 1257.965088,393.000000
	C1273.297852,393.000000 1288.631592,392.919037 1303.961792,393.116364
	C1305.624268,393.137726 1308.031372,394.342407 1308.797852,395.719269
	C1315.817871,408.327637 1322.582397,421.079041 1329.360718,433.821014
	C1339.097900,452.125366 1348.784668,470.456635 1358.684204,489.137329
	C1361.555054,483.804901 1364.331909,478.702240 1367.058228,473.572601
	C1376.117065,456.527252 1385.130249,439.457458 1394.216675,422.426819
	C1399.027832,413.409210 1403.871826,404.406189 1408.924683,395.523865
	C1409.618286,394.304596 1411.602661,393.119659 1413.000122,393.106964
	C1430.825562,392.945068 1448.652954,393.000214 1467.363403,393.000214
	C1464.264893,398.608765 1461.551514,403.795044 1458.587891,408.834076
	C1448.895630,425.313141 1439.114014,441.739685 1429.363525,458.184570
	C1417.714844,477.831085 1406.052979,497.469696 1394.418945,517.124817
	C1391.119019,522.699951 1387.796509,528.266785 1384.712769,533.961121
	C1383.995972,535.284546 1384.029175,537.113525 1384.027222,538.710327
	C1383.990112,568.542480 1384.000000,598.374634 1384.000000,628.206848
	C1384.000000,629.995239 1384.000000,631.783630 1384.000000,633.782349
	C1367.289673,633.782349 1351.010376,633.782349 1334.000000,633.782349
	C1334.000000,632.123047 1334.000000,630.374695 1334.000000,628.626343
	C1334.000000,601.627380 1333.946655,574.628235 1334.036865,547.629578
	C1334.059937,540.699646 1334.578247,533.761597 1329.270020,527.774780
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M439.003448,351.960938
	C432.968292,362.542328 426.964539,372.738068 421.010834,382.962891
	C410.577698,400.880676 400.154633,418.804382 389.766602,436.748322
	C381.812592,450.487885 373.952209,464.281647 365.991272,478.017181
	C351.366943,503.249542 336.650909,528.428894 322.069702,553.686096
	C314.726593,566.405640 307.595306,579.247498 300.200653,592.330505
	C291.083832,583.721191 282.200165,575.331970 273.056580,566.697388
	C342.035156,447.139374 410.965637,327.664734 480.416962,207.287323
	C484.231445,213.717850 487.671844,219.415833 491.009460,225.173386
	C494.258484,230.778152 497.435638,236.425613 500.549835,242.106140
	C500.936218,242.810898 501.122925,244.053040 500.762665,244.677032
	C489.668579,263.893463 478.451721,283.039001 467.346039,302.248779
	C457.857513,318.661255 448.482483,335.139313 439.003448,351.960938
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M233.000000,694.000000
	C352.125488,694.000000 470.750946,694.000000 589.782288,694.000000
	C583.627625,706.050781 577.592285,717.867981 571.461304,729.872437
	C441.063843,729.872437 310.453583,729.872437 178.958023,729.872437
	C185.934067,717.753296 192.720856,705.963013 199.607040,694.000000
	C210.519882,694.000000 221.509949,694.000000 233.000000,694.000000
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M617.000488,516.003784
	C593.731812,475.590332 570.516541,435.549438 547.007507,395.001801
	C560.693237,395.001801 573.791077,394.913361 586.883789,395.131836
	C588.267395,395.154938 590.137634,396.681732 590.911072,398.015839
	C603.016541,418.897736 614.903931,439.905975 626.992676,460.797638
	C642.243408,487.153748 657.699890,513.390808 672.940430,539.752625
	C687.368774,564.709595 701.573303,589.795898 715.985535,614.762207
	C730.237488,639.450806 744.677734,664.030762 758.934448,688.716614
	C766.692749,702.150391 774.241150,715.705444 782.141541,729.660339
	C780.666992,729.788635 779.452637,729.983582 778.237915,729.986145
	C767.074890,730.009644 755.904602,729.775452 744.753235,730.135376
	C741.359741,730.244873 739.517151,728.893250 738.115967,726.452332
	C726.101135,705.523010 714.229675,684.511108 702.174561,663.605164
	C690.605896,643.542542 678.799561,623.617065 667.225769,603.557373
	C655.165527,582.654541 643.280762,561.650574 631.273376,540.717224
	C626.598083,532.566528 621.797424,524.487793 617.000488,516.003784
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M2568.007812,503.037537
	C2562.638672,504.380493 2557.710693,506.557281 2552.682129,506.821899
	C2541.731689,507.398071 2530.729980,506.999786 2519.374756,506.999786
	C2519.374756,483.512207 2519.374756,460.136719 2519.374756,436.000000
	C2524.653076,436.000000 2530.231445,436.076416 2535.807129,435.983643
	C2546.485107,435.806061 2557.100342,436.001862 2567.245605,439.982239
	C2578.946533,444.572998 2587.460449,455.100983 2588.133789,468.994659
	C2588.871582,484.225403 2582.751465,495.141815 2569.819092,502.631104
	C2569.411865,502.867096 2568.877930,502.884705 2568.007812,503.037537
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M2853.748047,490.384521
	C2857.783691,499.796783 2861.613770,508.872955 2865.462402,517.941162
	C2868.549805,525.215820 2871.659424,532.480957 2874.821045,539.895264
	C2855.482422,539.895264 2836.528076,539.895264 2817.203125,539.895264
	C2826.836182,517.798401 2836.371338,495.926483 2846.168457,473.453400
	C2848.866699,479.517792 2851.208740,484.781403 2853.748047,490.384521
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M1981.122803,505.000000
	C1979.193359,504.931152 1977.750732,504.862305 1976.164307,504.786621
	C1976.164307,481.871460 1976.164307,459.283142 1976.164307,436.000000
	C1986.731934,436.000000 1997.342407,435.460144 2007.863037,436.198914
	C2014.354858,436.654816 2020.937744,438.446716 2027.074585,440.728638
	C2036.941284,444.397400 2043.075562,452.070435 2044.578613,462.401276
	C2045.922852,471.642181 2045.889526,481.008514 2040.172974,489.374390
	C2033.906128,498.545624 2024.630371,502.669922 2014.309082,503.807556
	C2003.496826,504.999329 1992.516479,504.666504 1981.122803,505.000000
z"
      />
    </Svg>
  );
};

const LogoOnly: FC<Omit<SvgProps, 'children'>> = (props) => {
  return (
    <Svg viewBox="0 0 3478 899" width="348" height="200" {...props}>
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M2139.000000,898.000000
	C1426.000000,898.000000 713.500000,898.000000 1.000000,898.000000
	C1.000000,599.000000 1.000000,300.000000 1.000000,1.000000
	C1027.000000,1.000000 2053.000000,1.000000 3079.000000,1.000000
	C3079.000000,300.000000 3079.000000,599.000000 3079.000000,898.000000
	C2765.833252,898.000000 2452.666748,898.000000 2139.000000,898.000000
M232.537964,558.956177
	C230.687332,562.004944 228.984833,565.157104 226.947525,568.075562
	C224.552597,571.506287 225.134064,573.826843 228.167648,576.826172
	C252.937515,601.315979 277.500000,626.015381 302.157532,650.619019
	C303.383667,651.842468 304.906006,652.769043 306.290436,653.833862
	C305.995636,654.222595 305.700836,654.611267 305.406036,655.000000
	C303.787231,655.000000 302.168427,655.000000 300.549622,655.000000
	C260.549835,655.000000 220.550003,654.978149 180.550491,655.078369
	C178.915436,655.082458 176.465897,655.752441 175.772568,656.925720
	C165.638519,674.075439 155.766891,691.379883 145.775360,708.614258
	C137.321869,723.195557 128.750244,737.708496 120.323067,752.304871
	C117.291725,757.555298 114.529167,762.960815 111.262970,769.000000
	C114.209076,769.000000 116.173798,769.000000 118.138527,769.000000
	C274.304321,769.000000 430.470215,768.943726 586.635620,769.193726
	C593.281250,769.204407 596.489136,767.026367 599.300171,761.451233
	C610.264282,739.706238 621.525085,718.108643 632.899414,696.574402
	C635.441833,691.761230 636.692566,687.581787 632.610474,683.011414
	C631.030151,681.242004 630.177368,678.829163 628.959229,676.729126
	C613.997192,650.935303 598.957581,625.186218 584.081848,599.342834
	C568.497925,572.269043 553.069763,545.105591 537.584290,518.000122
	C507.634003,518.000122 477.971924,517.952209 448.311188,518.130188
	C446.691315,518.139893 444.476807,519.656250 443.568085,521.113098
	C437.997223,530.044189 432.665405,539.126831 427.374298,548.228943
	C424.675018,552.872559 422.226349,557.661865 419.330994,563.000000
	C422.194702,563.000000 424.016449,563.000000 425.838196,563.000000
	C451.171387,563.000000 476.504730,562.964355 501.837402,563.079590
	C503.544891,563.087341 506.095642,563.724976 506.818115,564.930359
	C512.732605,574.798279 518.251770,584.902039 523.995972,594.873596
	C532.081726,608.909790 540.291504,622.874451 548.378418,636.910034
	C551.727539,642.722778 554.895813,648.639771 558.360535,654.896118
	C474.944061,654.896118 392.286377,654.896118 308.820862,654.896118
	C366.012115,556.011230 423.005432,457.468445 480.472900,358.105957
	C491.822693,377.690155 502.587585,396.153381 513.242432,414.679840
	C525.277588,435.606354 537.139221,456.632843 549.214661,477.535919
	C560.723328,497.457855 572.496460,517.227051 583.995178,537.154663
	C596.139832,558.201721 608.008057,579.408447 620.161621,600.450256
	C633.292786,623.184509 646.657532,645.783813 659.836975,668.490417
	C667.886536,682.358765 675.732117,696.345520 683.753479,710.230347
	C694.127075,728.186829 704.686096,746.037109 714.915344,764.074951
	C716.829773,767.450928 718.648499,769.121704 722.817993,769.104126
	C763.650391,768.931396 804.483765,769.000000 845.316895,769.000000
	C846.706970,769.000000 848.097046,769.000000 849.977112,769.000000
	C846.383179,762.438416 843.246948,756.421753 839.848022,750.557434
	C825.383545,725.601929 810.784302,700.724487 796.345276,675.754272
	C784.750610,655.702881 773.387146,635.517822 761.791809,615.466858
	C747.352051,590.497253 732.764709,565.612976 718.269836,540.675232
	C710.048706,526.531189 701.886414,512.352966 693.695312,498.191467
	C683.473022,480.518372 673.231140,462.856628 663.030029,445.171326
	C654.612549,430.578247 646.256226,415.949951 637.846741,401.352264
	C629.919250,387.591339 621.756775,373.959595 614.162415,360.017792
	C612.415649,356.811096 610.730713,355.932220 607.390442,355.939972
	C567.390869,356.032867 527.390991,356.000000 487.391235,356.000000
	C485.785370,356.000000 484.179535,356.000000 482.128357,356.000000
	C482.817383,354.597351 483.260712,353.562653 483.813263,352.590027
	C491.653809,338.788666 499.424835,324.946808 507.380402,311.211884
	C519.966675,289.482178 532.716187,267.846863 545.245972,246.084839
	C545.999756,244.775589 546.087402,242.333252 545.367432,241.040619
	C537.959351,227.740097 530.353577,214.549042 522.738831,201.364456
	C509.451569,178.358017 496.125641,155.373856 482.781647,132.400284
	C482.261108,131.504089 481.387207,130.813171 480.677979,130.026566
	C479.819489,130.849823 478.712738,131.530228 478.143311,132.519821
	C474.751740,138.413849 471.550385,144.417282 468.162567,150.313538
	C458.800964,166.606689 449.396576,182.875366 439.975159,199.134079
	C431.932709,213.013092 423.803741,226.842056 415.785004,240.734680
	C406.472473,256.868805 397.240723,273.049591 387.969635,289.207642
	C379.743469,303.544556 371.538513,317.893768 363.274750,332.209015
	C353.879120,348.484924 344.398682,364.711853 335.010437,380.992004
	C325.783447,396.992371 316.651123,413.047241 307.430847,429.051453
	C297.970734,445.472015 288.465820,461.866730 278.958923,478.260254
	C271.886108,490.456451 264.722351,502.600250 257.701508,514.826172
	C249.393768,529.292969 241.196045,543.822937 232.537964,558.956177
M1660.998657,576.498535
	C1667.652832,587.243591 1674.315796,597.983215 1680.955933,608.736938
	C1683.037964,612.109192 1684.066406,611.981812 1686.297852,608.321899
	C1692.200928,598.639832 1698.180908,589.004517 1704.143555,579.358826
	C1716.749512,558.966370 1729.348389,538.569641 1741.984619,518.196045
	C1745.336304,512.791809 1748.812744,507.464752 1752.693359,501.378662
	C1757.861450,546.296021 1762.897339,590.064697 1767.919067,633.710083
	C1785.698853,633.710083 1802.784790,633.710083 1820.041382,633.710083
	C1808.107178,549.385986 1796.216553,465.370667 1784.168701,380.244446
	C1750.210449,432.618225 1717.005249,483.830383 1683.538086,535.446533
	C1649.757568,483.948792 1616.976807,432.501556 1583.468018,381.537811
	C1583.137207,381.822754 1582.806396,382.107697 1582.475708,382.392639
	C1570.631958,466.102142 1558.788086,549.811646 1546.906982,633.785156
	C1564.395752,633.785156 1581.494507,633.785156 1599.032593,633.785156
	C1604.025269,590.479675 1609.006226,547.276855 1613.987183,504.074097
	C1614.414062,503.960144 1614.840942,503.846161 1615.267700,503.732178
	C1616.195679,504.934662 1617.226318,506.072113 1618.035645,507.349762
	C1625.670044,519.402405 1633.344238,531.431030 1640.851196,543.562988
	C1647.494995,554.300232 1653.940674,565.160095 1660.998657,576.498535
M1098.531738,635.006958
	C1102.629761,633.547363 1106.868530,632.392334 1110.801147,630.574646
	C1126.764404,623.195740 1140.522339,612.950806 1151.507202,599.047913
	C1161.380371,586.552124 1168.896729,572.848145 1172.919434,557.444641
	C1175.126221,548.994141 1176.889038,540.358032 1177.941406,531.695007
	C1179.005005,522.938599 1178.944580,514.045654 1179.369263,505.360596
	C1138.926392,505.360596 1099.535522,505.360596 1060.210327,505.360596
	C1060.210327,518.666138 1060.210327,531.610168 1060.210327,544.971497
	C1083.105469,544.971497 1105.795776,544.971497 1129.324829,544.971497
	C1126.625488,550.932800 1124.604370,556.440857 1121.753540,561.479553
	C1115.388428,572.729248 1107.004883,582.159546 1095.164429,587.960022
	C1080.708862,595.041687 1065.606567,597.155823 1049.528198,595.160950
	C1033.234863,593.139465 1019.158020,586.856018 1007.406799,575.753174
	C994.380005,563.445251 986.762146,548.190491 983.847900,530.335632
	C981.460510,515.709351 981.868347,501.361359 986.096985,487.281647
	C992.421448,466.223785 1005.412903,450.576752 1025.509277,441.157013
	C1035.981567,436.248383 1046.929077,434.166901 1058.578979,433.829254
	C1081.135254,433.175568 1100.020386,440.343750 1114.887451,457.450806
	C1118.059937,461.101288 1120.839111,465.093781 1123.845093,468.987640
	C1137.930908,460.809143 1152.022705,452.627228 1166.476807,444.234863
	C1159.439087,433.818176 1151.843262,424.617828 1142.408936,416.732361
	C1122.650879,400.218201 1099.854248,391.082092 1074.516357,389.259308
	C1059.311279,388.165497 1043.972412,388.480438 1028.711914,391.792603
	C1001.480835,397.702850 978.145630,409.754211 959.590637,430.843292
	C941.143372,451.809814 932.123962,476.568542 930.147400,503.970276
	C929.201111,517.088440 930.046936,530.248291 932.891724,543.270508
	C938.773315,570.194336 951.081909,593.113464 972.436462,611.039307
	C996.426880,631.177612 1024.448486,639.788025 1055.176147,640.919739
	C1061.246704,641.143311 1067.421387,640.780518 1073.430176,639.890869
	C1081.582764,638.683655 1089.621460,636.708130 1098.531738,635.006958
M2647.330566,634.000000
	C2649.528564,634.000000 2651.726562,634.000000 2654.688965,634.000000
	C2632.687744,602.553467 2611.352539,572.058472 2589.902832,541.400208
	C2591.497070,540.795593 2592.562012,540.417908 2593.606934,539.991516
	C2610.870117,532.947815 2624.602539,521.636353 2632.519775,504.680298
	C2640.073975,488.501984 2641.633545,471.389648 2638.147217,453.591309
	C2632.831299,426.451752 2615.966309,409.997772 2591.314697,399.954346
	C2577.387939,394.280396 2562.634277,393.569519 2548.031006,393.178986
	C2523.553711,392.524384 2499.045898,393.000000 2474.551025,393.000000
	C2472.785645,393.000000 2471.020508,393.000000 2469.314453,393.000000
	C2469.314453,473.656738 2469.314453,553.708923 2469.314453,633.659180
	C2486.027100,633.659180 2502.423096,633.659180 2519.270752,633.659180
	C2519.270752,604.590942 2519.270752,575.861755 2519.270752,547.000000
	C2524.886963,547.000000 2530.072998,546.697815 2535.192383,547.149780
	C2537.220703,547.328979 2539.822021,548.697876 2540.934082,550.351379
	C2549.442627,563.001770 2557.700439,575.822571 2565.934814,588.655518
	C2575.030762,602.832214 2583.930908,617.136108 2593.180908,631.210754
	C2594.180664,632.731812 2596.927002,633.854248 2598.880615,633.880554
	C2614.707764,634.093323 2630.539062,634.000000 2647.330566,634.000000
M2200.097900,393.765900
	C2200.068359,473.232880 2200.037598,552.699829 2200.031006,632.166809
	C2200.031006,632.762085 2200.360840,633.357361 2200.488525,633.788940
	C2251.357178,633.788940 2301.955566,633.788940 2352.764893,633.788940
	C2352.764893,619.851318 2352.764893,606.125000 2352.764893,591.949219
	C2317.810059,591.949219 2283.087158,591.949219 2248.270996,591.949219
	C2248.270996,570.107483 2248.270996,548.716431 2248.270996,526.876221
	C2280.929688,526.876221 2313.320068,526.876221 2345.688721,526.876221
	C2345.688721,513.029175 2345.688721,499.635071 2345.688721,485.795563
	C2312.989014,485.795563 2280.598633,485.795563 2248.350342,485.795563
	C2248.350342,468.949036 2248.350342,452.555115 2248.350342,435.718567
	C2283.422363,435.718567 2318.145264,435.718567 2352.787354,435.718567
	C2352.787354,421.325623 2352.787354,407.383118 2352.787354,393.095520
	C2301.978760,393.095520 2251.381836,393.095520 2200.097900,393.765900
M2946.496094,587.995667
	C2945.011475,584.762146 2943.568848,581.508606 2942.035645,578.298218
	C2930.506836,554.154236 2918.974365,530.011902 2907.414307,505.882812
	C2899.988281,490.383575 2892.502441,474.913086 2885.062744,459.420410
	C2872.221680,432.680023 2859.395508,405.932404 2846.422119,378.894012
	C2845.838867,379.901855 2845.306885,380.693756 2844.898682,381.545105
	C2838.246094,395.427124 2831.611328,409.317688 2824.967773,423.204193
	C2813.632324,446.898651 2802.296143,470.592743 2790.955811,494.284882
	C2779.614990,517.977539 2768.306152,541.685486 2756.914307,565.353577
	C2746.640869,586.697998 2736.273438,607.997314 2725.949951,629.317505
	C2725.270020,630.722168 2724.610596,632.136658 2723.726807,633.999146
	C2742.314697,633.999146 2760.294434,634.047058 2778.271973,633.892334
	C2779.482910,633.881958 2781.272217,632.612000 2781.795898,631.470398
	C2789.630615,614.396912 2797.297607,597.246521 2804.983154,580.160828
	C2832.450684,580.160828 2859.576904,580.160828 2886.671875,580.160828
	C2895.053467,598.182617 2903.368164,616.060425 2911.392822,633.314758
	C2930.447510,633.314758 2949.072998,633.314758 2968.291016,633.314758
	C2960.920898,617.883606 2953.932373,603.251770 2946.496094,587.995667
M2001.499268,547.000000
	C2014.192017,547.415833 2026.734009,546.490906 2039.020630,543.009338
	C2063.914795,535.955322 2082.144287,521.526794 2090.278564,496.234222
	C2095.039307,481.431458 2095.232910,466.339722 2092.021484,451.146332
	C2087.795898,431.154968 2076.659180,416.282867 2059.113281,406.003174
	C2041.621338,395.754944 2022.180786,393.619080 2002.600220,393.140900
	C1978.459839,392.551331 1954.294189,392.997070 1930.139404,393.008362
	C1928.861572,393.008972 1927.583862,393.130066 1926.258545,393.197510
	C1926.258545,473.577148 1926.258545,553.612854 1926.258545,633.720093
	C1942.910034,633.720093 1959.301514,633.720093 1976.140015,633.720093
	C1976.140015,604.720154 1976.140015,575.996887 1976.140015,547.000000
	C1984.557739,547.000000 1992.528564,547.000000 2001.499268,547.000000
M1329.535400,528.043091
	C1334.578247,533.761597 1334.059937,540.699646 1334.036865,547.629578
	C1333.946655,574.628235 1334.000000,601.627380 1334.000000,628.626343
	C1334.000000,630.374695 1334.000000,632.123047 1334.000000,633.782349
	C1351.010376,633.782349 1367.289673,633.782349 1384.000000,633.782349
	C1384.000000,631.783630 1384.000000,629.995239 1384.000000,628.206848
	C1384.000000,598.374634 1383.990112,568.542480 1384.027222,538.710327
	C1384.029175,537.113525 1383.995972,535.284546 1384.712769,533.961121
	C1387.796509,528.266785 1391.119019,522.699951 1394.418945,517.124817
	C1406.052979,497.469696 1417.714844,477.831085 1429.363525,458.184570
	C1439.114014,441.739685 1448.895630,425.313141 1458.587891,408.834076
	C1461.551514,403.795044 1464.264893,398.608765 1467.363403,393.000214
	C1448.652954,393.000214 1430.825562,392.945068 1413.000122,393.106964
	C1411.602661,393.119659 1409.618286,394.304596 1408.924683,395.523865
	C1403.871826,404.406189 1399.027832,413.409210 1394.216675,422.426819
	C1385.130249,439.457458 1376.117065,456.527252 1367.058228,473.572601
	C1364.331909,478.702240 1361.555054,483.804901 1358.684204,489.137329
	C1348.784668,470.456635 1339.097900,452.125366 1329.360718,433.821014
	C1322.582397,421.079041 1315.817871,408.327637 1308.797852,395.719269
	C1308.031372,394.342407 1305.624268,393.137726 1303.961792,393.116364
	C1288.631592,392.919037 1273.297852,393.000000 1257.965088,393.000000
	C1255.713623,393.000000 1253.462158,393.000000 1250.151611,393.000000
	C1276.787720,438.435455 1302.896240,482.970978 1329.535400,528.043091
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M232.744308,558.640869
	C241.196045,543.822937 249.393768,529.292969 257.701508,514.826172
	C264.722351,502.600250 271.886108,490.456451 278.958923,478.260254
	C288.465820,461.866730 297.970734,445.472015 307.430847,429.051453
	C316.651123,413.047241 325.783447,396.992371 335.010437,380.992004
	C344.398682,364.711853 353.879120,348.484924 363.274750,332.209015
	C371.538513,317.893768 379.743469,303.544556 387.969635,289.207642
	C397.240723,273.049591 406.472473,256.868805 415.785004,240.734680
	C423.803741,226.842056 431.932709,213.013092 439.975159,199.134079
	C449.396576,182.875366 458.800964,166.606689 468.162567,150.313538
	C471.550385,144.417282 474.751740,138.413849 478.143311,132.519821
	C478.712738,131.530228 479.819489,130.849823 480.677979,130.026581
	C481.387207,130.813171 482.261108,131.504089 482.781647,132.400284
	C496.125641,155.373856 509.451569,178.358017 522.738831,201.364456
	C530.353577,214.549042 537.959351,227.740097 545.367432,241.040619
	C546.087402,242.333252 545.999756,244.775589 545.245972,246.084839
	C532.716187,267.846863 519.966675,289.482178 507.380402,311.211884
	C499.424835,324.946808 491.653809,338.788666 483.813263,352.590027
	C483.260712,353.562653 482.817383,354.597351 482.128357,356.000000
	C484.179535,356.000000 485.785370,356.000000 487.391235,356.000000
	C527.390991,356.000000 567.390869,356.032867 607.390442,355.939972
	C610.730713,355.932220 612.415649,356.811096 614.162415,360.017792
	C621.756775,373.959595 629.919250,387.591339 637.846741,401.352264
	C646.256226,415.949951 654.612549,430.578247 663.030029,445.171326
	C673.231140,462.856628 683.473022,480.518372 693.695312,498.191467
	C701.886414,512.352966 710.048706,526.531189 718.269836,540.675232
	C732.764709,565.612976 747.352051,590.497253 761.791809,615.466858
	C773.387146,635.517822 784.750610,655.702881 796.345276,675.754272
	C810.784302,700.724487 825.383545,725.601929 839.848022,750.557434
	C843.246948,756.421753 846.383179,762.438416 849.977112,769.000000
	C848.097046,769.000000 846.706970,769.000000 845.316895,769.000000
	C804.483765,769.000000 763.650391,768.931396 722.817993,769.104126
	C718.648499,769.121704 716.829773,767.450928 714.915344,764.074951
	C704.686096,746.037109 694.127075,728.186829 683.753479,710.230347
	C675.732117,696.345520 667.886536,682.358765 659.836975,668.490417
	C646.657532,645.783813 633.292786,623.184509 620.161621,600.450256
	C608.008057,579.408447 596.139832,558.201721 583.995178,537.154663
	C572.496460,517.227051 560.723328,497.457855 549.214661,477.535919
	C537.139221,456.632843 525.277588,435.606354 513.242432,414.679840
	C502.587585,396.153381 491.822693,377.690155 480.472900,358.105957
	C423.005432,457.468445 366.012115,556.011230 308.820862,654.896118
	C392.286377,654.896118 474.944061,654.896118 558.360535,654.896118
	C554.895813,648.639771 551.727539,642.722778 548.378418,636.910034
	C540.291504,622.874451 532.081726,608.909790 523.995972,594.873596
	C518.251770,584.902039 512.732605,574.798279 506.818115,564.930359
	C506.095642,563.724976 503.544891,563.087341 501.837402,563.079590
	C476.504730,562.964355 451.171387,563.000000 425.838196,563.000000
	C424.016449,563.000000 422.194702,563.000000 419.330994,563.000000
	C422.226349,557.661865 424.675018,552.872559 427.374298,548.228943
	C432.665405,539.126831 437.997223,530.044189 443.568085,521.113098
	C444.476807,519.656250 446.691315,518.139893 448.311188,518.130188
	C477.971924,517.952209 507.634003,518.000122 537.584290,518.000122
	C553.069763,545.105591 568.497925,572.269043 584.081848,599.342834
	C598.957581,625.186218 613.997192,650.935303 628.959229,676.729126
	C630.177368,678.829163 631.030151,681.242004 632.610474,683.011414
	C636.692566,687.581787 635.441833,691.761230 632.899414,696.574402
	C621.525085,718.108643 610.264282,739.706238 599.300171,761.451233
	C596.489136,767.026367 593.281250,769.204407 586.635620,769.193726
	C430.470215,768.943726 274.304321,769.000000 118.138527,769.000000
	C116.173798,769.000000 114.209076,769.000000 111.262970,769.000000
	C114.529167,762.960815 117.291725,757.555298 120.323067,752.304871
	C128.750244,737.708496 137.321869,723.195557 145.775360,708.614258
	C155.766891,691.379883 165.638519,674.075439 175.772568,656.925720
	C176.465897,655.752441 178.915436,655.082458 180.550491,655.078369
	C220.550003,654.978149 260.549835,655.000000 300.549622,655.000000
	C302.168427,655.000000 303.787231,655.000000 305.406036,655.000000
	C305.700836,654.611267 305.995636,654.222595 306.290436,653.833862
	C304.906006,652.769043 303.383667,651.842468 302.157532,650.619019
	C277.500000,626.015381 252.937515,601.315979 228.167648,576.826172
	C225.134064,573.826843 224.552597,571.506287 226.947525,568.075562
	C228.984833,565.157104 230.687332,562.004944 232.744308,558.640869
M439.057343,351.588379
	C448.482483,335.139313 457.857513,318.661255 467.346039,302.248779
	C478.451721,283.039001 489.668579,263.893463 500.762665,244.677032
	C501.122925,244.053040 500.936218,242.810898 500.549835,242.106140
	C497.435638,236.425613 494.258484,230.778152 491.009460,225.173386
	C487.671844,219.415833 484.231445,213.717850 480.416962,207.287323
	C410.965637,327.664734 342.035156,447.139374 273.056580,566.697388
	C282.200165,575.331970 291.083832,583.721191 300.200653,592.330505
	C307.595306,579.247498 314.726593,566.405640 322.069702,553.686096
	C336.650909,528.428894 351.366943,503.249542 365.991272,478.017181
	C373.952209,464.281647 381.812592,450.487885 389.766602,436.748322
	C400.154633,418.804382 410.577698,400.880676 421.010834,382.962891
	C426.964539,372.738068 432.968292,362.542328 439.057343,351.588379
M232.500000,694.000000
	C221.509949,694.000000 210.519882,694.000000 199.607040,694.000000
	C192.720856,705.963013 185.934067,717.753296 178.958023,729.872437
	C310.453583,729.872437 441.063843,729.872437 571.461304,729.872437
	C577.592285,717.867981 583.627625,706.050781 589.782288,694.000000
	C470.750946,694.000000 352.125488,694.000000 232.500000,694.000000
M617.053833,516.376282
	C621.797424,524.487793 626.598083,532.566528 631.273376,540.717224
	C643.280762,561.650574 655.165527,582.654541 667.225769,603.557373
	C678.799561,623.617065 690.605896,643.542542 702.174561,663.605164
	C714.229675,684.511108 726.101135,705.523010 738.115967,726.452332
	C739.517151,728.893250 741.359741,730.244873 744.753235,730.135376
	C755.904602,729.775452 767.074890,730.009644 778.237915,729.986145
	C779.452637,729.983582 780.666992,729.788635 782.141541,729.660339
	C774.241150,715.705444 766.692749,702.150391 758.934448,688.716614
	C744.677734,664.030762 730.237488,639.450806 715.985535,614.762207
	C701.573303,589.795898 687.368774,564.709595 672.940430,539.752625
	C657.699890,513.390808 642.243408,487.153748 626.992676,460.797638
	C614.903931,439.905975 603.016541,418.897736 590.911072,398.015839
	C590.137634,396.681732 588.267395,395.154938 586.883789,395.131836
	C573.791077,394.913361 560.693237,395.001801 547.007507,395.001801
	C570.516541,435.549438 593.731812,475.590332 617.053833,516.376282
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M1660.736328,576.232178
	C1653.940674,565.160095 1647.494995,554.300232 1640.851196,543.562988
	C1633.344238,531.431030 1625.670044,519.402405 1618.035645,507.349762
	C1617.226318,506.072113 1616.195679,504.934662 1615.267700,503.732178
	C1614.840942,503.846161 1614.414062,503.960144 1613.987183,504.074097
	C1609.006226,547.276855 1604.025269,590.479675 1599.032593,633.785156
	C1581.494507,633.785156 1564.395752,633.785156 1546.906982,633.785156
	C1558.788086,549.811646 1570.631958,466.102142 1582.475708,382.392639
	C1582.806396,382.107697 1583.137207,381.822754 1583.468018,381.537811
	C1616.976807,432.501556 1649.757568,483.948792 1683.538086,535.446533
	C1717.005249,483.830383 1750.210449,432.618225 1784.168701,380.244446
	C1796.216553,465.370667 1808.107178,549.385986 1820.041382,633.710083
	C1802.784790,633.710083 1785.698853,633.710083 1767.919067,633.710083
	C1762.897339,590.064697 1757.861450,546.296021 1752.693359,501.378662
	C1748.812744,507.464752 1745.336304,512.791809 1741.984619,518.196045
	C1729.348389,538.569641 1716.749512,558.966370 1704.143555,579.358826
	C1698.180908,589.004517 1692.200928,598.639832 1686.297852,608.321899
	C1684.066406,611.981812 1683.037964,612.109192 1680.955933,608.736938
	C1674.315796,597.983215 1667.652832,587.243591 1660.736328,576.232178
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M1098.120361,635.034546
	C1089.621460,636.708130 1081.582764,638.683655 1073.430176,639.890869
	C1067.421387,640.780518 1061.246704,641.143311 1055.176147,640.919739
	C1024.448486,639.788025 996.426880,631.177612 972.436462,611.039307
	C951.081909,593.113464 938.773315,570.194336 932.891724,543.270508
	C930.046936,530.248291 929.201111,517.088440 930.147400,503.970276
	C932.123962,476.568542 941.143372,451.809814 959.590637,430.843292
	C978.145630,409.754211 1001.480835,397.702850 1028.711914,391.792603
	C1043.972412,388.480438 1059.311279,388.165497 1074.516357,389.259308
	C1099.854248,391.082092 1122.650879,400.218201 1142.408936,416.732361
	C1151.843262,424.617828 1159.439087,433.818176 1166.476807,444.234863
	C1152.022705,452.627228 1137.930908,460.809143 1123.845093,468.987640
	C1120.839111,465.093781 1118.059937,461.101288 1114.887451,457.450806
	C1100.020386,440.343750 1081.135254,433.175568 1058.578979,433.829254
	C1046.929077,434.166901 1035.981567,436.248383 1025.509277,441.157013
	C1005.412903,450.576752 992.421448,466.223785 986.096985,487.281647
	C981.868347,501.361359 981.460510,515.709351 983.847900,530.335632
	C986.762146,548.190491 994.380005,563.445251 1007.406799,575.753174
	C1019.158020,586.856018 1033.234863,593.139465 1049.528198,595.160950
	C1065.606567,597.155823 1080.708862,595.041687 1095.164429,587.960022
	C1107.004883,582.159546 1115.388428,572.729248 1121.753540,561.479553
	C1124.604370,556.440857 1126.625488,550.932800 1129.324829,544.971497
	C1105.795776,544.971497 1083.105469,544.971497 1060.210327,544.971497
	C1060.210327,531.610168 1060.210327,518.666138 1060.210327,505.360596
	C1099.535522,505.360596 1138.926392,505.360596 1179.369263,505.360596
	C1178.944580,514.045654 1179.005005,522.938599 1177.941406,531.695007
	C1176.889038,540.358032 1175.126221,548.994141 1172.919434,557.444641
	C1168.896729,572.848145 1161.380371,586.552124 1151.507202,599.047913
	C1140.522339,612.950806 1126.764404,623.195740 1110.801147,630.574646
	C1106.868530,632.392334 1102.629761,633.547363 1098.120361,635.034546
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M2646.849854,634.000000
	C2630.539062,634.000000 2614.707764,634.093323 2598.880615,633.880554
	C2596.927002,633.854248 2594.180664,632.731812 2593.180908,631.210754
	C2583.930908,617.136108 2575.030762,602.832214 2565.934814,588.655518
	C2557.700439,575.822571 2549.442627,563.001770 2540.934082,550.351379
	C2539.822021,548.697876 2537.220703,547.328979 2535.192383,547.149780
	C2530.072998,546.697815 2524.886963,547.000000 2519.270752,547.000000
	C2519.270752,575.861755 2519.270752,604.590942 2519.270752,633.659180
	C2502.423096,633.659180 2486.027100,633.659180 2469.314453,633.659180
	C2469.314453,553.708923 2469.314453,473.656738 2469.314453,393.000000
	C2471.020508,393.000000 2472.785645,393.000000 2474.551025,393.000000
	C2499.045898,393.000000 2523.553711,392.524384 2548.031006,393.178986
	C2562.634277,393.569519 2577.387939,394.280396 2591.314697,399.954346
	C2615.966309,409.997772 2632.831299,426.451752 2638.147217,453.591309
	C2641.633545,471.389648 2640.073975,488.501984 2632.519775,504.680298
	C2624.602539,521.636353 2610.870117,532.947815 2593.606934,539.991516
	C2592.562012,540.417908 2591.497070,540.795593 2589.902832,541.400208
	C2611.352539,572.058472 2632.687744,602.553467 2654.688965,634.000000
	C2651.726562,634.000000 2649.528564,634.000000 2646.849854,634.000000
M2568.403076,503.004181
	C2568.877930,502.884705 2569.411865,502.867096 2569.819092,502.631104
	C2582.751465,495.141815 2588.871582,484.225403 2588.133789,468.994659
	C2587.460449,455.100983 2578.946533,444.572998 2567.245605,439.982239
	C2557.100342,436.001862 2546.485107,435.806061 2535.807129,435.983643
	C2530.231445,436.076416 2524.653076,436.000000 2519.374756,436.000000
	C2519.374756,460.136719 2519.374756,483.512207 2519.374756,506.999786
	C2530.729980,506.999786 2541.731689,507.398071 2552.682129,506.821899
	C2557.710693,506.557281 2562.638672,504.380493 2568.403076,503.004181
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M2200.441406,393.430725
	C2251.381836,393.095520 2301.978760,393.095520 2352.787354,393.095520
	C2352.787354,407.383118 2352.787354,421.325623 2352.787354,435.718567
	C2318.145264,435.718567 2283.422363,435.718567 2248.350342,435.718567
	C2248.350342,452.555115 2248.350342,468.949036 2248.350342,485.795563
	C2280.598633,485.795563 2312.989014,485.795563 2345.688721,485.795563
	C2345.688721,499.635071 2345.688721,513.029175 2345.688721,526.876221
	C2313.320068,526.876221 2280.929688,526.876221 2248.270996,526.876221
	C2248.270996,548.716431 2248.270996,570.107483 2248.270996,591.949219
	C2283.087158,591.949219 2317.810059,591.949219 2352.764893,591.949219
	C2352.764893,606.125000 2352.764893,619.851318 2352.764893,633.788940
	C2301.955566,633.788940 2251.357178,633.788940 2200.488525,633.788940
	C2200.360840,633.357361 2200.031006,632.762085 2200.031006,632.166809
	C2200.037598,552.699829 2200.068359,473.232880 2200.441406,393.430725
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M2946.720215,588.307861
	C2953.932373,603.251770 2960.920898,617.883606 2968.291016,633.314758
	C2949.072998,633.314758 2930.447510,633.314758 2911.392822,633.314758
	C2903.368164,616.060425 2895.053467,598.182617 2886.671875,580.160828
	C2859.576904,580.160828 2832.450684,580.160828 2804.983154,580.160828
	C2797.297607,597.246521 2789.630615,614.396912 2781.795898,631.470398
	C2781.272217,632.612000 2779.482910,633.881958 2778.271973,633.892334
	C2760.294434,634.047058 2742.314697,633.999146 2723.726807,633.999146
	C2724.610596,632.136658 2725.270020,630.722168 2725.949951,629.317505
	C2736.273438,607.997314 2746.640869,586.697998 2756.914307,565.353577
	C2768.306152,541.685486 2779.614990,517.977539 2790.955811,494.284882
	C2802.296143,470.592743 2813.632324,446.898651 2824.967773,423.204193
	C2831.611328,409.317688 2838.246094,395.427124 2844.898682,381.545105
	C2845.306885,380.693756 2845.838867,379.901855 2846.422119,378.894012
	C2859.395508,405.932404 2872.221680,432.680023 2885.062744,459.420410
	C2892.502441,474.913086 2899.988281,490.383575 2907.414307,505.882812
	C2918.974365,530.011902 2930.506836,554.154236 2942.035645,578.298218
	C2943.568848,581.508606 2945.011475,584.762146 2946.720215,588.307861
M2853.550781,490.045044
	C2851.208740,484.781403 2848.866699,479.517792 2846.168457,473.453400
	C2836.371338,495.926483 2826.836182,517.798401 2817.203125,539.895264
	C2836.528076,539.895264 2855.482422,539.895264 2874.821045,539.895264
	C2871.659424,532.480957 2868.549805,525.215820 2865.462402,517.941162
	C2861.613770,508.872955 2857.783691,499.796783 2853.550781,490.045044
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M2000.999390,547.000000
	C1992.528564,547.000000 1984.557739,547.000000 1976.140015,547.000000
	C1976.140015,575.996887 1976.140015,604.720154 1976.140015,633.720093
	C1959.301514,633.720093 1942.910034,633.720093 1926.258545,633.720093
	C1926.258545,553.612854 1926.258545,473.577148 1926.258545,393.197510
	C1927.583862,393.130066 1928.861572,393.008972 1930.139404,393.008362
	C1954.294189,392.997070 1978.459839,392.551331 2002.600220,393.140900
	C2022.180786,393.619080 2041.621338,395.754944 2059.113281,406.003174
	C2076.659180,416.282867 2087.795898,431.154968 2092.021484,451.146332
	C2095.232910,466.339722 2095.039307,481.431458 2090.278564,496.234222
	C2082.144287,521.526794 2063.914795,535.955322 2039.020630,543.009338
	C2026.734009,546.490906 2014.192017,547.415833 2000.999390,547.000000
M1981.609619,505.000031
	C1992.516479,504.666504 2003.496826,504.999329 2014.309082,503.807556
	C2024.630371,502.669922 2033.906128,498.545624 2040.172974,489.374390
	C2045.889526,481.008514 2045.922852,471.642181 2044.578613,462.401276
	C2043.075562,452.070435 2036.941284,444.397400 2027.074585,440.728638
	C2020.937744,438.446716 2014.354858,436.654816 2007.863037,436.198914
	C1997.342407,435.460144 1986.731934,436.000000 1976.164307,436.000000
	C1976.164307,459.283142 1976.164307,481.871460 1976.164307,504.786621
	C1977.750732,504.862305 1979.193359,504.931152 1981.609619,505.000031
z"
      />
      <path
        fill="#FFF"
        opacity="1.000000"
        stroke="none"
        d="
M1329.270020,527.774780
	C1302.896240,482.970978 1276.787720,438.435455 1250.151611,393.000000
	C1253.462158,393.000000 1255.713623,393.000000 1257.965088,393.000000
	C1273.297852,393.000000 1288.631592,392.919037 1303.961792,393.116364
	C1305.624268,393.137726 1308.031372,394.342407 1308.797852,395.719269
	C1315.817871,408.327637 1322.582397,421.079041 1329.360718,433.821014
	C1339.097900,452.125366 1348.784668,470.456635 1358.684204,489.137329
	C1361.555054,483.804901 1364.331909,478.702240 1367.058228,473.572601
	C1376.117065,456.527252 1385.130249,439.457458 1394.216675,422.426819
	C1399.027832,413.409210 1403.871826,404.406189 1408.924683,395.523865
	C1409.618286,394.304596 1411.602661,393.119659 1413.000122,393.106964
	C1430.825562,392.945068 1448.652954,393.000214 1467.363403,393.000214
	C1464.264893,398.608765 1461.551514,403.795044 1458.587891,408.834076
	C1448.895630,425.313141 1439.114014,441.739685 1429.363525,458.184570
	C1417.714844,477.831085 1406.052979,497.469696 1394.418945,517.124817
	C1391.119019,522.699951 1387.796509,528.266785 1384.712769,533.961121
	C1383.995972,535.284546 1384.029175,537.113525 1384.027222,538.710327
	C1383.990112,568.542480 1384.000000,598.374634 1384.000000,628.206848
	C1384.000000,629.995239 1384.000000,631.783630 1384.000000,633.782349
	C1367.289673,633.782349 1351.010376,633.782349 1334.000000,633.782349
	C1334.000000,632.123047 1334.000000,630.374695 1334.000000,628.626343
	C1334.000000,601.627380 1333.946655,574.628235 1334.036865,547.629578
	C1334.059937,540.699646 1334.578247,533.761597 1329.270020,527.774780
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M439.003448,351.960938
	C432.968292,362.542328 426.964539,372.738068 421.010834,382.962891
	C410.577698,400.880676 400.154633,418.804382 389.766602,436.748322
	C381.812592,450.487885 373.952209,464.281647 365.991272,478.017181
	C351.366943,503.249542 336.650909,528.428894 322.069702,553.686096
	C314.726593,566.405640 307.595306,579.247498 300.200653,592.330505
	C291.083832,583.721191 282.200165,575.331970 273.056580,566.697388
	C342.035156,447.139374 410.965637,327.664734 480.416962,207.287323
	C484.231445,213.717850 487.671844,219.415833 491.009460,225.173386
	C494.258484,230.778152 497.435638,236.425613 500.549835,242.106140
	C500.936218,242.810898 501.122925,244.053040 500.762665,244.677032
	C489.668579,263.893463 478.451721,283.039001 467.346039,302.248779
	C457.857513,318.661255 448.482483,335.139313 439.003448,351.960938
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M233.000000,694.000000
	C352.125488,694.000000 470.750946,694.000000 589.782288,694.000000
	C583.627625,706.050781 577.592285,717.867981 571.461304,729.872437
	C441.063843,729.872437 310.453583,729.872437 178.958023,729.872437
	C185.934067,717.753296 192.720856,705.963013 199.607040,694.000000
	C210.519882,694.000000 221.509949,694.000000 233.000000,694.000000
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M617.000488,516.003784
	C593.731812,475.590332 570.516541,435.549438 547.007507,395.001801
	C560.693237,395.001801 573.791077,394.913361 586.883789,395.131836
	C588.267395,395.154938 590.137634,396.681732 590.911072,398.015839
	C603.016541,418.897736 614.903931,439.905975 626.992676,460.797638
	C642.243408,487.153748 657.699890,513.390808 672.940430,539.752625
	C687.368774,564.709595 701.573303,589.795898 715.985535,614.762207
	C730.237488,639.450806 744.677734,664.030762 758.934448,688.716614
	C766.692749,702.150391 774.241150,715.705444 782.141541,729.660339
	C780.666992,729.788635 779.452637,729.983582 778.237915,729.986145
	C767.074890,730.009644 755.904602,729.775452 744.753235,730.135376
	C741.359741,730.244873 739.517151,728.893250 738.115967,726.452332
	C726.101135,705.523010 714.229675,684.511108 702.174561,663.605164
	C690.605896,643.542542 678.799561,623.617065 667.225769,603.557373
	C655.165527,582.654541 643.280762,561.650574 631.273376,540.717224
	C626.598083,532.566528 621.797424,524.487793 617.000488,516.003784
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M2568.007812,503.037537
	C2562.638672,504.380493 2557.710693,506.557281 2552.682129,506.821899
	C2541.731689,507.398071 2530.729980,506.999786 2519.374756,506.999786
	C2519.374756,483.512207 2519.374756,460.136719 2519.374756,436.000000
	C2524.653076,436.000000 2530.231445,436.076416 2535.807129,435.983643
	C2546.485107,435.806061 2557.100342,436.001862 2567.245605,439.982239
	C2578.946533,444.572998 2587.460449,455.100983 2588.133789,468.994659
	C2588.871582,484.225403 2582.751465,495.141815 2569.819092,502.631104
	C2569.411865,502.867096 2568.877930,502.884705 2568.007812,503.037537
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M2853.748047,490.384521
	C2857.783691,499.796783 2861.613770,508.872955 2865.462402,517.941162
	C2868.549805,525.215820 2871.659424,532.480957 2874.821045,539.895264
	C2855.482422,539.895264 2836.528076,539.895264 2817.203125,539.895264
	C2826.836182,517.798401 2836.371338,495.926483 2846.168457,473.453400
	C2848.866699,479.517792 2851.208740,484.781403 2853.748047,490.384521
z"
      />
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M1981.122803,505.000000
	C1979.193359,504.931152 1977.750732,504.862305 1976.164307,504.786621
	C1976.164307,481.871460 1976.164307,459.283142 1976.164307,436.000000
	C1986.731934,436.000000 1997.342407,435.460144 2007.863037,436.198914
	C2014.354858,436.654816 2020.937744,438.446716 2027.074585,440.728638
	C2036.941284,444.397400 2043.075562,452.070435 2044.578613,462.401276
	C2045.922852,471.642181 2045.889526,481.008514 2040.172974,489.374390
	C2033.906128,498.545624 2024.630371,502.669922 2014.309082,503.807556
	C2003.496826,504.999329 1992.516479,504.666504 1981.122803,505.000000
z"
      />
    </Svg>
  );
};
export default {
  Default,
  LogoOnly,
  Admin,
};
